{
  "app": {
    "name": "HMS",
    "fullName": "医院管理系统",
    "tagline": "协同医疗，用心守护。"
  },
  "common": {
    "save": "保存",
    "saving": "正在保存…",
    "cancel": "取消",
    "close": "关闭",
    "edit": "编辑",
    "delete": "删除",
    "add": "添加",
    "create": "创建",
    "search": "搜索",
    "searchPlaceholder": "搜索…",
    "loading": "加载中…",
    "retry": "重试",
    "back": "返回",
    "next": "下一页",
    "previous": "上一页",
    "confirm": "确认",
    "yes": "是",
    "no": "否",
    "actions": "操作",
    "status": "状态",
    "details": "详情",
    "none": "无",
    "all": "全部",
    "optional": "可选",
    "required": "必填",
    "notes": "备注",
    "reason": "原因",
    "date": "日期",
    "time": "时间",
    "from": "从",
    "to": "至",
    "filter": "筛选",
    "clear": "清除",
    "refresh": "刷新",
    "print": "打印",
    "export": "导出",
    "import": "导入",
    "reset": "重置",
    "view": "查看",
    "open": "打开",
    "submit": "提交",
    "select": "选择",
    "selectPlaceholder": "请选择…",
    "noResults": "未找到结果",
    "total": "合计",
    "showing": "第 {{from}}–{{to}} 条，共 {{total}} 条",
    "unknown": "未知",
    "saved": "已保存",
    "today": "今天",
    "name": "名称",
    "code": "代码",
    "type": "类型",
    "description": "描述",
    "createdAt": "创建时间",
    "updatedAt": "更新时间",
    "yearsShort": "{{count}} 岁",
    "dash": "—",
    "more": "更多",
    "active": "启用",
    "inactive": "停用",
    "first": "首页",
    "last": "末页",
    "pageOf": "第 {{page}} / {{pages}} 页",
    "rowsPerPage": "每页行数",
    "pagination": "分页",
    "viewAs": "显示方式",
    "views": {
      "list": "列表",
      "cards": "卡片",
      "grid": "网格"
    },
    "datePlaceholder": "日/月/年",
    "pickDate": "选择日期",
    "change": "更换",
    "goToPage": "跳至",
    "jumpBack": "向前 {{count}} 页",
    "jumpForward": "向后 {{count}} 页",
    "cancelled": "已取消",
    "choose": "请选择…",
    "selectAll": "全选"
  },
  "nav": {
    "dashboard": "仪表盘",
    "patients": "患者",
    "appointments": "预约",
    "queue": "排队",
    "encounters": "就诊",
    "pharmacy": "药房",
    "laboratory": "检验科",
    "billing": "收费",
    "administration": "系统管理",
    "users": "用户",
    "departments": "科室",
    "practitioners": "医护人员",
    "hospital": "医院",
    "auditLog": "审计日志",
    "translations": "翻译",
    "languages": "语言",
    "settings": "设置",
    "notifications": "通知",
    "signOut": "退出登录",
    "menu": "菜单",
    "home": "首页",
    "eyeCenter": "眼科中心",
    "treatmentCycles": "治疗周期",
    "patientApp": "患者应用",
    "reports": "报表",
    "locations": "地区",
    "inventory": "库存",
    "inpatient": "住院",
    "bedBoard": "床位看板",
    "admissions": "入院记录",
    "wardSetup": "病区、病房与床位",
    "specialServices": "特殊检查与服务",
    "serviceWorklist": "工作列表",
    "serviceCatalog": "服务项目与价格",
    "pos": "医疗零售 POS",
    "posCounter": "销售",
    "salesHistory": "销售记录",
    "itemsPrices": "物品与价格",
    "finance": "财务",
    "collapseMenu": "收起菜单",
    "expandMenu": "展开菜单",
    "posStock": "库存与补货",
    "posCatalog": "商品目录与价格",
    "diseases": "疾病",
    "nationalReporting": "国家报告",
    "area": {
      "patientAdmin": "患者管理",
      "clinical": "临床诊疗",
      "eye": "眼科中心",
      "inpatient": "住院",
      "supplies": "药品与物资",
      "finance": "财务",
      "reporting": "绩效与国家报告",
      "engagement": "患者服务",
      "platform": "系统与管理"
    },
    "tenants": "租户与医院",
    "referrals": "转诊",
    "followUps": "随访",
    "duplicates": "重复患者",
    "roles": "角色与权限",
    "appointmentDashboard": "看板",
    "appointmentList": "预约列表",
    "disabilityTypes": "残疾类型",
    "queueDashboard": "员工工作台",
    "queueKiosk": "自助服务机",
    "queueDisplay": "候诊区显示屏",
    "queueReport": "等候时间",
    "queueServices": "排队服务点",
    "staffKpi": "员工 KPI",
    "staffDashboard": "看板",
    "staffLeaderboard": "排行榜",
    "staffTargets": "目标"
  },
  "auth": {
    "signIn": "登录",
    "signInTitle": "欢迎回来",
    "signInSubtitle": "登录以进入医院工作台。",
    "username": "用户名或邮箱",
    "password": "密码",
    "signingIn": "正在登录…",
    "sessionExpired": "会话已过期，请重新登录。",
    "changePassword": "修改密码",
    "currentPassword": "当前密码",
    "newPassword": "新密码",
    "confirmPassword": "确认新密码",
    "passwordMismatch": "两次输入的密码不一致",
    "passwordChanged": "密码已修改，请重新登录。",
    "passwordPolicy": "至少 8 个字符，包含大写字母、小写字母和数字。",
    "switchHospital": "切换医院",
    "hospital": "医院",
    "demoAccounts": "演示账号",
    "showPassword": "显示密码",
    "hidePassword": "隐藏密码",
    "usernamePlaceholder": "例如 doctor",
    "featureClinical": "患者、就诊、药房、检验和收费一体化",
    "featureAnalytics": "实时仪表盘与同比分析",
    "featureLanguages": "老挝语、泰语、英语、中文和越南语 — 用语可自定义",
    "featureSecurity": "基于角色的权限与完整审计追踪",
    "stats": {
      "title": "实时统计",
      "patients": "登记患者",
      "newThisMonth": "本月 +{{count}}",
      "visitsThisYear": "今年就诊",
      "today": "今日 {{count}}",
      "eyeExams": "眼科检查",
      "surgeries": "眼科手术 {{count}} 例",
      "villages": "服务村庄",
      "provinces": "覆盖 {{count}} 个省",
      "departments": "临床科室",
      "practitioners": "医生 {{count}} 名",
      "appAccounts": "患者应用用户",
      "patientApp": "通过手机应用",
      "visitsByMonth": "每月就诊（近 12 个月）"
    },
    "app": {
      "title": "手机应用",
      "download": "下载 APK",
      "scan": "用手机扫码",
      "howTo": "安装方法",
      "step1": "在安卓手机上下载 APK（Android 7.0 或更高版本）。",
      "step2": "打开文件，并在提示时允许安装此来源的应用。",
      "step3": "打开应用：患者用手机号或邮箱创建账户；员工用用户名登录。",
      "version": "Android · 版本 {{version}} · {{date}}",
      "patient": {
        "name": "HMS 患者版",
        "desc": "面向患者：用手机号或邮箱注册，查看病历、排队和账单"
      },
      "staff": {
        "name": "HMS 员工版",
        "desc": "面向医院员工：使用 HMS 账户登录"
      }
    }
  },
  "errors": {
    "generic": "出现错误，请重试。",
    "network": "无法连接服务器，请检查网络。",
    "UNAUTHORIZED": "请登录后继续。",
    "INVALID_CREDENTIALS": "用户名或密码错误。",
    "ACCOUNT_LOCKED": "多次登录失败，账号已被临时锁定，请稍后再试。",
    "ACCOUNT_DISABLED": "账户已停用，请联系医院。",
    "TOKEN_INVALID": "会话已失效，请重新登录。",
    "TOKEN_REUSED": "为安全起见会话已结束，请重新登录。",
    "SESSION_EXPIRED": "会话已过期，请重新登录。",
    "NO_HOSPITAL_ACCESS": "您的账号尚未分配任何医院的权限。",
    "HOSPITAL_ACCESS_DENIED": "您无权访问该医院。",
    "FORBIDDEN": "您没有执行此操作的权限。",
    "NOT_FOUND": "未找到请求的记录。",
    "VALIDATION_FAILED": "请修正标出的字段。",
    "INVALID_JSON": "无法读取请求内容。",
    "INVALID_PARAMETER": "筛选条件无效。",
    "DUPLICATE": "已存在相同值的记录。",
    "CONFLICT": "与现有数据冲突。",
    "VERSION_CONFLICT": "该记录已被他人修改，请刷新后重试。",
    "SCHEDULE_CONFLICT": "该时间段与此医生的其他预约冲突。",
    "INVALID_STATE": "当前状态下不允许此操作。",
    "INVALID_TRANSITION": "当前状态下不允许此操作。",
    "MRN_EXISTS": "该病历号已被使用。",
    "DUPLICATE_IDENTIFIER": "已存在使用该证件号的患者。",
    "POTENTIAL_DUPLICATE": "已存在相似的患者。",
    "ALLERGY_WARNING": "该药物与已记录的过敏史相符。",
    "OVERPAYMENT": "金额超过未付余额。",
    "TOO_MANY_REQUESTS": "请求过于频繁，请稍候。",
    "INTERNAL_ERROR": "服务器发生意外错误。",
    "UNSIGNED_NOTES": "请先签署或删除草稿记录再结束就诊。",
    "ENCOUNTER_CLOSED": "该就诊已结束。",
    "ENCOUNTER_EXISTS": "该预约已有就诊记录。",
    "ENCOUNTER_HAS_ACTIVITY": "已有签署记录或医嘱的就诊不能取消。",
    "QUEUE_CLOSED": "该科室的排队已关闭。",
    "INVOICE_HAS_PAYMENTS": "请先退款再作废账单。",
    "EMPTY_INVOICE": "账单至少需要一个项目。",
    "SPECIMEN_NOT_COLLECTED": "请先采集标本再录入结果。",
    "RESULT_VERIFIED": "已审核的结果只能通过更正流程修改。",
    "NOTHING_TO_DISPENSE": "没有需要发放的药品。",
    "QUANTITY_EXCEEDED": "数量超过处方数量。",
    "CANNOT_DISABLE_SELF": "不能停用自己的账号。",
    "CONSTRAINT_VIOLATION": "数据违反了临床或业务规则。",
    "INVALID_REFERENCE": "引用的记录不存在。",
    "PATIENT_INACTIVE": "该患者档案未启用。",
    "PATIENT_MISMATCH": "所选记录属于其他患者。",
    "NOTE_SIGNED": "已签署的记录不能编辑，请创建补充修订。",
    "NOTE_NOT_SIGNED": "只能修订已签署的记录。",
    "NO_DEPARTMENT": "请先选择科室。",
    "IDEMPOTENCY_KEY_REUSED": "该付款请求已用于其他账单。",
    "LOCALE_REQUIRED": "不能停用英语。",
    "RETRY": "记录正被占用，请重试。",
    "EXAM_SIGNED": "该检查已签署，如需更改请创建修订。",
    "EXAM_EMPTY": "签署前请至少记录一项检查结果。",
    "EXAM_EXISTS": "本次就诊已有进行中的眼科检查。",
    "EXAM_NOT_SIGNED": "只能修订已签署的检查。",
    "EYE_SIDE_MISMATCH": "眼别不符：与计划或测量结果不一致。",
    "PREOP_NOT_CONFIRMED": "请先完成术前安全核查。",
    "BIOMETRY_REQUIRED": "白内障手术需要手术眼的生物测量。",
    "IOL_NOT_SELECTED": "确认前请选择人工晶状体。",
    "IOL_POWER_MISMATCH": "植入晶状体度数与所选方案不一致。",
    "IMPLANT_EXPIRED": "植入物已过期。",
    "MEDICATION_EXPIRED": "该批次药品已过期。",
    "IOL_OUT_OF_RANGE": "测量值超出公式适用范围。",
    "BIOMETRY_LOCKED": "该生物测量已用于手术。",
    "DATE_IN_PAST": "日期已过去。",
    "PATHWAY_SHARED": "共享模板为只读，请复制到本院后再修改。",
    "STAGE_IN_USE": "有患者处于该阶段，无法删除。",
    "PATHWAY_ARCHIVED": "该治疗周期已归档。",
    "ACTIVATION_INVALID": "激活码无效或已过期。",
    "OTP_INVALID": "验证码错误。",
    "OTP_EXPIRED": "验证码已过期，请重新获取。",
    "OTP_LOCKED": "错误次数过多，请重新获取。",
    "OTP_RATE_LIMITED": "请求过于频繁，请稍后再试。",
    "VERIFICATION_REQUIRED": "请先到挂号处出示身份证件。",
    "QUEUE_PAUSED": "该科室暂停应用取号。",
    "EID_INVALID": "二维码无效或已过期，请患者刷新。",
    "EID_OTHER_HOSPITAL": "该二维码属于其他医院。",
    "PHOTO_TOO_LARGE": "照片不能超过 2 MB",
    "PHOTO_INVALID": "请上传 JPEG、PNG 或 WebP 图片",
    "SUBDISTRICT_IN_USE": "该乡/片区有患者居住，无法删除",
    "INSUFFICIENT_STOCK": "可用库存不足",
    "SELF_APPROVAL": "自己制作的单据必须由他人审核或批准",
    "NO_DISPENSING_STORE": "未设置发药仓库",
    "NOTHING_APPROVED": "请至少批准一行，或驳回申请",
    "DUPLICATE_LINE": "每个物品只能出现一次",
    "DISCOUNT_EXCEEDS_BALANCE": "折扣后金额低于已付款",
    "BED_UNAVAILABLE": "该床位不可用",
    "BED_OCCUPIED": "床位已被占用",
    "ALREADY_ADMITTED": "患者已在院",
    "WARD_OCCUPIED": "病区仍有患者",
    "ROOM_OCCUPIED": "房间内有床位被占用",
    "DISCHARGE_PENDING": "尚有未完成的工作",
    "ADMISSION_HAS_ACTIVITY": "已有医嘱或账单，请办理出院",
    "SAME_BED": "患者已在该床位",
    "ALREADY_BILLED": "已开票，请先作废发票",
    "NOT_FOR_SALE": "该物品不销售",
    "PATIENT_REQUIRED": "管制药品请选择患者",
    "NO_CASH_SESSION": "请先开启收银班次",
    "SESSION_OPEN": "您已有未关闭的收银班次",
    "SESSION_CLOSED": "该收银班次已关闭，请改为退货",
    "STORE_INACTIVE": "该仓库已停用",
    "TOO_MANY_IMAGES": "图片过多",
    "POS_REFILL_ONLY": "发往 POS 门店的库存须通过 POS 补货申请发出",
    "POS_OUTLET": "POS 门店库存只能通过补货和销售变动",
    "NOT_A_POS_OUTLET": "销售须在 POS 门店进行",
    "NOT_IN_CATALOG": "只能申请 POS 目录中的商品",
    "NOTHING_TO_SEND": "无可发货：仓库没有所申请的商品",
    "EXCEEDS_SENT": "收货数量超过发货数量",
    "DUPLICATE_CODE": "该代码已被使用",
    "TYPE_IN_USE": "该类别仍有疾病，请移走疾病或改为停用。",
    "SEGREGATION_OF_DUTIES": "必须由创建者以外的人批准",
    "NOT_DRAFT": "仅草稿可执行此操作",
    "NOT_VALIDATED": "请先校验",
    "NOT_APPROVED": "必须先批准",
    "SNAPSHOT_HAS_ERRORS": "快照有错误；请修正后生成新版本",
    "HASH_MISMATCH": "快照内容与其指纹不符",
    "SNAPSHOT_FINAL": "此快照不能再更改",
    "SNAPSHOT_NOT_APPROVED": "报告快照必须已批准",
    "OPEN_BATCH_EXISTS": "相同数据的另一批次仍未完成",
    "MAPPING_OVERLAP": "已有其他映射覆盖这些日期；请先停用",
    "METADATA_MISSING": "请先刷新 DHIS2 元数据",
    "INSTANCE_DISABLED": "此 DHIS2 连接已停用",
    "NOT_RETRYABLE": "此批次不能重新发送",
    "NOT_RECONCILABLE": "只能核对已发送的批次",
    "NOT_CANCELLABLE": "此批次已不能取消",
    "INVALID_PERIOD": "请输入 202610、2026Q4 或 2026 这样的报告期",
    "PERIOD_TYPE_MISMATCH": "报告期与报告频率不符",
    "REPORT_RETIRED": "此报告已停用",
    "REPORT_EMPTY": "此报告没有启用的 KPI",
    "NO_DIRECTION": "请先设置越高越好或越低越好",
    "DUPLICATE_NAME": "此名称已被使用",
    "UNKNOWN_CALCULATOR": "未知的计算器",
    "CONCURRENT_CHANGE": "数据已被修改，请重试",
    "ALREADY_RETIRED": "已停用",
    "OWN_TENANT": "不能暂停您当前登录的租户",
    "OWN_HOSPITAL": "不能停用您当前登录的医院",
    "REFERRAL_CLOSED": "已结束的转诊不能修改",
    "PATIENT_MERGED": "此患者记录已合并到其他记录",
    "MERGE_PENDING": "这两条记录的合并已在等待审批",
    "BOTH_ADMITTED": "两条记录都在住院；请先办理其中一条的出院",
    "FOLLOW_UP_CLOSED": "此随访已结束",
    "NOT_REQUESTED": "此申请已经处理",
    "ROLE_LOCKED": "超级管理员始终拥有所有权限",
    "ROLE_BUILT_IN": "内置角色不能删除；请移除其权限",
    "ROLE_IN_USE": "此角色仍分配给用户",
    "DISABILITY_TYPE_IN_USE": "有患者属于此残疾类型，请改为停用。",
    "DISABILITY_TYPE_HAS_SUB_TYPES": "请先删除或移动其子类型。"
  },
  "validation": {
    "required": "必填",
    "invalid": "无效的值",
    "invalidType": "无效的值",
    "tooLong": "内容过长",
    "invalidOption": "请选择有效选项",
    "invalidDate": "请输入有效日期",
    "invalidDateTime": "请输入有效的日期和时间",
    "invalidNumber": "请输入数字",
    "invalidInteger": "请输入整数",
    "outOfRange": "数值超出范围",
    "invalidEmail": "请输入有效的邮箱地址",
    "invalidPhone": "请输入有效的电话号码",
    "implausibleDate": "日期不合理",
    "weakPassword": "密码强度不足",
    "incorrect": "不正确",
    "inPast": "时间已过去",
    "invalidKey": "无效的翻译键",
    "invalidValue": "无效的翻译文本",
    "tooMany": "条目过多",
    "mustConfirm": "必须确认",
    "eyeSideMismatch": "眼别与检查不符",
    "beforeStart": "必须晚于开始日期",
    "invalidUrl": "请输入有效链接",
    "exceedsOutstanding": "超过未到货数量",
    "expired": "已过期",
    "exceedsAvailable": "超过可用数量",
    "insufficient": "不足",
    "duplicate": "重复",
    "min": "数值过小",
    "max": "数值过大",
    "notDiscountable": "此收费项目不可打折",
    "belowMin": "不得低于最低值",
    "inFuture": "不能是将来的时间",
    "tooOld": "时间太早（最多 30 天前）",
    "beforeAdmission": "不能早于入院或最近一次换床时间",
    "httpsRequired": "生产环境必须使用 https",
    "notFound": "未找到",
    "notAllowed": "此处不允许",
    "platformOnly": "只有超级管理员可以拥有平台权限",
    "disabilityAlone": "此类型不能与其他类型同时选择",
    "disabilityOneSubtype": "此处只能选择一个子类型",
    "tooDeep": "层级过多"
  },
  "enums": {
    "sex": {
      "MALE": "男",
      "FEMALE": "女",
      "OTHER": "其他",
      "UNKNOWN": "未知"
    },
    "maritalStatus": {
      "SINGLE": "未婚",
      "MARRIED": "已婚",
      "DIVORCED": "离异",
      "WIDOWED": "丧偶",
      "SEPARATED": "分居",
      "UNKNOWN": "未知"
    },
    "patientStatus": {
      "ACTIVE": "启用",
      "INACTIVE": "停用",
      "DECEASED": "已故",
      "MERGED": "已合并"
    },
    "appointmentStatus": {
      "BOOKED": "已预约",
      "CONFIRMED": "已确认",
      "CHECKED_IN": "已签到",
      "IN_PROGRESS": "就诊中",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消",
      "NO_SHOW": "爽约"
    },
    "encounterStatus": {
      "PLANNED": "计划中",
      "IN_PROGRESS": "进行中",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消"
    },
    "encounterType": {
      "OPD": "门诊",
      "IPD": "住院",
      "EMERGENCY": "急诊",
      "TELEMEDICINE": "远程医疗",
      "HOME_VISIT": "家庭访视"
    },
    "ticketStatus": {
      "WAITING": "等候中",
      "CALLED": "已叫号",
      "SERVING": "服务中",
      "SERVED": "已服务",
      "SKIPPED": "已过号",
      "CANCELLED": "已取消",
      "TRANSFERRED": "已转送"
    },
    "queuePriority": {
      "NORMAL": "普通",
      "URGENT": "紧急",
      "EMERGENCY": "急诊",
      "PRIORITY": "优先"
    },
    "labPriority": {
      "ROUTINE": "常规",
      "URGENT": "加急",
      "STAT": "立即"
    },
    "labOrderStatus": {
      "ORDERED": "已开单",
      "COLLECTED": "已采样",
      "IN_PROGRESS": "检测中",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消"
    },
    "labItemStatus": {
      "ORDERED": "已开单",
      "RESULTED": "已出结果",
      "VERIFIED": "已审核",
      "CANCELLED": "已取消"
    },
    "resultStatus": {
      "PRELIMINARY": "初步结果",
      "VERIFIED": "已审核",
      "CORRECTED": "已更正"
    },
    "resultFlag": {
      "N": "正常",
      "L": "偏低",
      "H": "偏高",
      "LL": "危急低值",
      "HH": "危急高值",
      "A": "异常"
    },
    "prescriptionStatus": {
      "ISSUED": "已开具",
      "PARTIALLY_DISPENSED": "部分发药",
      "DISPENSED": "已发药",
      "CANCELLED": "已取消"
    },
    "invoiceStatus": {
      "DRAFT": "草稿",
      "ISSUED": "未付款",
      "PARTIALLY_PAID": "部分付款",
      "PAID": "已付款",
      "VOID": "已作废"
    },
    "paymentStatus": {
      "PENDING": "待确认",
      "COMPLETED": "已完成",
      "FAILED": "失败",
      "REFUNDED": "已退款"
    },
    "paymentMethod": {
      "CASH": "现金",
      "CARD": "银行卡",
      "BANK_TRANSFER": "银行转账",
      "QR": "扫码支付",
      "MOBILE_MONEY": "移动支付",
      "INSURANCE": "保险"
    },
    "allergySeverity": {
      "MILD": "轻度",
      "MODERATE": "中度",
      "SEVERE": "重度",
      "LIFE_THREATENING": "危及生命"
    },
    "allergyStatus": {
      "ACTIVE": "活动",
      "INACTIVE": "非活动",
      "RESOLVED": "已消退",
      "ENTERED_IN_ERROR": "录入错误"
    },
    "alertSeverity": {
      "INFO": "提示",
      "WARNING": "警告",
      "CRITICAL": "危急"
    },
    "noteType": {
      "SOAP": "SOAP",
      "PROGRESS": "病程记录",
      "ADMISSION": "入院记录",
      "DISCHARGE": "出院记录",
      "NURSING": "护理记录",
      "CONSULT": "会诊记录",
      "PROCEDURE": "操作记录"
    },
    "noteStatus": {
      "DRAFT": "草稿",
      "SIGNED": "已签署",
      "AMENDED": "已修订"
    },
    "diagnosisType": {
      "PRIMARY": "主要诊断",
      "SECONDARY": "次要诊断",
      "ADMITTING": "入院诊断",
      "DISCHARGE": "出院诊断",
      "DIFFERENTIAL": "鉴别诊断"
    },
    "verificationStatus": {
      "PROVISIONAL": "初步",
      "CONFIRMED": "确诊",
      "REFUTED": "排除",
      "ENTERED_IN_ERROR": "录入错误"
    },
    "departmentType": {
      "CLINICAL": "临床",
      "DIAGNOSTIC": "医技",
      "SUPPORT": "后勤支持",
      "ADMINISTRATIVE": "行政"
    },
    "userStatus": {
      "ACTIVE": "启用",
      "LOCKED": "已锁定",
      "DISABLED": "已停用"
    },
    "role": {
      "SUPER_ADMIN": "超级管理员",
      "HOSPITAL_ADMIN": "医院管理员",
      "DOCTOR": "医生",
      "NURSE": "护士",
      "RECEPTIONIST": "前台挂号员",
      "PHARMACIST": "药剂师",
      "LAB_TECHNICIAN": "检验人员",
      "CASHIER": "收费员",
      "OPTOMETRIST": "验光师",
      "INVENTORY_MANAGER": "库存管理员",
      "PROCUREMENT_APPROVER": "采购审批人",
      "IMAGING_TECHNICIAN": "影像技师",
      "ACCOUNTANT": "财务人员",
      "POS_MANAGER": "药房柜台经理",
      "REPORTING_OFFICER": "国家报告专员",
      "REPORTING_APPROVER": "报告审批人",
      "SYSTEM_ADMIN": "系统管理员",
      "HOSPITAL_DIRECTOR": "医院院长",
      "MEDICAL_DIRECTOR": "医务主任",
      "OPHTHALMOLOGIST": "眼科医生",
      "OPHTHALMIC_SURGEON": "眼科手术医生",
      "OPHTHALMIC_NURSE": "眼科护士",
      "DIAGNOSTIC_TECHNICIAN": "诊断技师",
      "MEDICAL_RECORDS_OFFICER": "病案管理员",
      "AUDITOR": "审计员",
      "QUEUE_DEVICE": "自助机 / 显示屏设备"
    },
    "medicationOrderStatus": {
      "ACTIVE": "待发药",
      "COMPLETED": "已发药",
      "CANCELLED": "已取消"
    },
    "eyeExamStatus": {
      "DRAFT": "草稿",
      "IN_PROGRESS": "进行中",
      "SIGNED": "已签署",
      "AMENDED": "已修订",
      "CANCELLED": "已取消"
    },
    "surgeryStatus": {
      "PLANNED": "已计划",
      "CONFIRMED": "核查已确认",
      "IN_PROGRESS": "手术中",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消"
    },
    "followUpStatus": {
      "SCHEDULED": "已安排",
      "COMPLETED": "已完成",
      "MISSED": "未到",
      "CANCELLED": "已取消"
    },
    "eyeMedStatus": {
      "ACTIVE": "使用中",
      "COMPLETED": "已完成",
      "STOPPED": "已停用"
    },
    "carePlanStatus": {
      "ACTIVE": "进行中",
      "COMPLETED": "已完成",
      "STOPPED": "已停止"
    },
    "portalStatus": {
      "ACTIVE": "应用已启用",
      "DISABLED": "应用已停用"
    },
    "portalVerification": {
      "VERIFIED": "身份已核验",
      "PENDING_VERIFICATION": "待核验身份"
    },
    "queueStatus": {
      "OPEN": "开放",
      "PAUSED": "暂停应用取号",
      "CLOSED": "已关闭"
    },
    "inventoryItemType": {
      "DRUG": "药品",
      "SUPPLY": "医用耗材",
      "EQUIPMENT": "设备",
      "DEVICE": "医疗器械（销售）"
    },
    "stockStatus": {
      "OUT": "缺货",
      "LOW": "偏低",
      "OK": "充足",
      "OVER": "超储",
      "ASSET": "按台",
      "EXPIRING": "90 天内到期"
    },
    "expiryStatus": {
      "EXPIRED": "已过期",
      "EXPIRING": "即将到期"
    },
    "lotStatus": {
      "AVAILABLE": "可用",
      "QUARANTINE": "待检"
    },
    "movementType": {
      "OPENING": "期初",
      "RECEIPT": "采购入库",
      "DISPENSE": "处方发药",
      "ISSUE": "科室领用",
      "TRANSFER_OUT": "调出",
      "TRANSFER_IN": "调入",
      "ADJUSTMENT_IN": "盘盈",
      "ADJUSTMENT_OUT": "盘亏",
      "WRITE_OFF": "报损",
      "RETURN_TO_SUPPLIER": "退货给供应商",
      "SALE": "柜台销售",
      "SALE_RETURN": "销售退货"
    },
    "adjustmentReason": {
      "OPENING_BALANCE": "期初余额",
      "COUNT_CORRECTION": "盘点更正",
      "DONATION": "捐赠",
      "FOUND": "盘盈",
      "EXPIRED": "过期",
      "DAMAGED": "损坏",
      "LOST": "丢失",
      "RECALLED": "召回",
      "DEFECTIVE": "有缺陷",
      "OTHER": "其他"
    },
    "prStatus": {
      "DRAFT": "草稿",
      "SUBMITTED": "待审批",
      "APPROVED": "已批准",
      "REJECTED": "已驳回",
      "ORDERED": "已下单",
      "CANCELLED": "已取消"
    },
    "prPriority": {
      "NORMAL": "普通",
      "URGENT": "紧急"
    },
    "poStatus": {
      "DRAFT": "草稿",
      "APPROVED": "已批准",
      "SENT": "已发出",
      "PARTIALLY_RECEIVED": "部分到货",
      "RECEIVED": "已收货",
      "CLOSED": "已关闭",
      "CANCELLED": "已取消"
    },
    "storeType": {
      "MAIN": "总库",
      "PHARMACY": "药房",
      "WARD": "病区库",
      "CLINIC": "门诊库",
      "POS": "POS 门店"
    },
    "assetStatus": {
      "IN_SERVICE": "在用",
      "UNDER_MAINTENANCE": "维修中",
      "OUT_OF_SERVICE": "停用",
      "DISPOSED": "已报废"
    },
    "assetEvent": {
      "MAINTENANCE": "预防性保养",
      "CALIBRATION": "校准",
      "INSPECTION": "检查",
      "REPAIR": "维修",
      "STATUS_CHANGE": "状态变更",
      "TRANSFER": "调拨"
    },
    "maintenanceStatus": {
      "OK": "正常",
      "DUE": "30 天内到期",
      "OVERDUE": "逾期",
      "NONE": "—"
    },
    "stockUnit": {
      "TABLET": "片",
      "CAPSULE": "胶囊",
      "BOTTLE": "瓶",
      "VIAL": "西林瓶",
      "AMPOULE": "安瓿",
      "SACHET": "袋",
      "TUBE": "支",
      "INHALER": "吸入器",
      "PIECE": "个",
      "BOX": "盒",
      "PACK": "包",
      "ROLL": "卷",
      "SYRINGE": "支",
      "SET": "套",
      "UNIT": "台/件"
    },
    "bedStatus": {
      "AVAILABLE": "空闲",
      "OCCUPIED": "占用",
      "CLEANING": "清洁中",
      "RESERVED": "已预留",
      "OUT_OF_SERVICE": "停用"
    },
    "roomType": {
      "STANDARD": "普通",
      "PRIVATE": "单人间",
      "VIP": "VIP",
      "ICU": "重症监护",
      "OBSERVATION": "留观",
      "ISOLATION": "隔离"
    },
    "wardType": {
      "GENERAL": "普通",
      "SURGICAL": "外科",
      "PEDIATRIC": "儿科",
      "MATERNITY": "产科",
      "ICU": "重症监护",
      "OBSERVATION": "留观",
      "ISOLATION": "隔离",
      "PRIVATE": "特需"
    },
    "bedType": {
      "STANDARD": "普通",
      "ELECTRIC": "电动床",
      "ICU": "ICU床",
      "PEDIATRIC": "儿童床",
      "CRIB": "婴儿床"
    },
    "admissionType": {
      "EMERGENCY": "急诊",
      "ELECTIVE": "择期",
      "TRANSFER_IN": "转入",
      "DAY_CASE": "日间",
      "MATERNITY": "分娩"
    },
    "admissionStatus": {
      "ADMITTED": "在院",
      "DISCHARGED": "已出院",
      "CANCELLED": "已取消"
    },
    "dischargeType": {
      "HOME": "回家",
      "REFERRED": "转诊",
      "AGAINST_ADVICE": "自动出院",
      "TRANSFERRED": "转院",
      "DECEASED": "死亡"
    },
    "stayReason": {
      "ADMISSION": "入院",
      "TRANSFER": "转床"
    },
    "serviceCategory": {
      "XRAY": "X光",
      "CT": "CT",
      "MRI": "磁共振",
      "ULTRASOUND": "超声",
      "ECG": "心电图",
      "ECHO": "心脏超声",
      "ENDOSCOPY": "内镜",
      "PHYSIOTHERAPY": "物理治疗",
      "DENTAL": "牙科",
      "PROCEDURE": "操作治疗",
      "OTHER": "其他"
    },
    "serviceOrderStatus": {
      "ORDERED": "已开单",
      "IN_PROGRESS": "进行中",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消"
    },
    "serviceItemStatus": {
      "ORDERED": "等待",
      "IN_PROGRESS": "进行中",
      "REPORTED": "已报告",
      "VERIFIED": "已审核",
      "CANCELLED": "已取消"
    },
    "saleStatus": {
      "COMPLETED": "已付款",
      "PARTIALLY_RETURNED": "部分退货",
      "RETURNED": "已退货",
      "VOIDED": "已作废"
    },
    "stockDocType": {
      "RECEIPT": "采购入库",
      "OPENING": "期初库存",
      "ADJUSTMENT_IN": "盘盈入库",
      "ISSUE": "领用单",
      "TRANSFER": "调拨",
      "ADJUSTMENT_OUT": "盘亏出库",
      "WRITE_OFF": "报损",
      "RETURN_TO_SUPPLIER": "退供应商"
    },
    "stockDocStatus": {
      "DRAFT": "草稿",
      "SUBMITTED": "待审核",
      "POSTED": "已过账",
      "REJECTED": "已驳回",
      "CANCELLED": "已取消",
      "IN_TRANSIT": "在途"
    },
    "expenseCategory": {
      "SUPPLIES": "耗材",
      "UTILITIES": "水电",
      "SALARIES": "工资",
      "MAINTENANCE": "维修保养",
      "RENT": "租金",
      "TRANSPORT": "交通运输",
      "MARKETING": "宣传推广",
      "TRAINING": "培训",
      "TAXES": "税费",
      "OTHER": "其他"
    },
    "expenseStatus": {
      "SUBMITTED": "待审批",
      "APPROVED": "已批准",
      "REJECTED": "已驳回",
      "CANCELLED": "已取消"
    },
    "cashSessionStatus": {
      "OPEN": "营业中",
      "CLOSED": "已关账待核",
      "VERIFIED": "已核对"
    },
    "priceType": {
      "CHARGE_ITEM": "收费项目",
      "SERVICE": "特殊服务",
      "MEDICATION": "药品",
      "LAB_TEST": "检验",
      "ROOM": "床位费",
      "INVENTORY_ITEM": "仓库建议价",
      "POS_PRODUCT": "医疗零售 POS"
    },
    "priceStatus": {
      "ACTIVE": "使用中",
      "INACTIVE": "停用",
      "DISCONTINUED": "已停产",
      "NOT_FOR_SALE": "不销售"
    },
    "discountType": {
      "AMOUNT": "金额",
      "PERCENT": "百分比"
    },
    "plSection": {
      "REVENUE": "收入",
      "COST": "销售成本",
      "EXPENSES": "费用",
      "RESULT": "结果"
    },
    "plLine": {
      "INVOICES": "患者账单",
      "POS_SALES": "柜台销售",
      "REFUNDS": "退款",
      "TOTAL_REVENUE": "总收入",
      "COST_OF_GOODS": "药品耗材成本",
      "GROSS_PROFIT": "毛利",
      "TOTAL_EXPENSES": "费用合计",
      "NET_PROFIT": "净利润"
    },
    "posLevel": {
      "OK": "充足",
      "LOW": "偏低",
      "OUT": "缺货"
    },
    "posProductStatus": {
      "PUBLISHED": "在 POS 显示",
      "HIDDEN": "已隐藏"
    },
    "outletStatus": {
      "ACTIVE": "使用中",
      "INACTIVE": "停用"
    },
    "refillStatus": {
      "DRAFT": "草稿",
      "SUBMITTED": "待仓库处理",
      "PREPARING": "备货中",
      "IN_TRANSIT": "运送中",
      "RECEIVED": "已收货",
      "REJECTED": "已拒绝",
      "CANCELLED": "已取消"
    },
    "patientTitle": {
      "MR": "先生 (ທ້າວ)",
      "MRS": "女士 (ນາງ)",
      "MISS": "小姐 (ນາງສາວ)",
      "BOY": "男童 (ເດັກຊາຍ)",
      "GIRL": "女童 (ເດັກຍິງ)",
      "DR": "博士 (ດຣ.)",
      "MONK": "僧人 (ພຣະ)",
      "NOVICE": "沙弥 (ສາມະເນນ)",
      "NUN": "女尼 (ແມ່ຂາວ)"
    },
    "reporting": {
      "ACHIEVED": "达成",
      "WARNING": "警告",
      "MISSED": "未达成",
      "INSUFFICIENT_DATA": "数据不足",
      "NOT_APPLICABLE": "无目标",
      "PENDING_REVIEW": "待审核",
      "OK": "正常",
      "INCOMPLETE": "不完整",
      "INVALID": "无效",
      "DRAFT": "草稿",
      "VALIDATED": "已校验",
      "APPROVED": "已批准",
      "SUPERSEDED": "已被取代",
      "INVALIDATED": "已作废",
      "ACTIVE": "启用",
      "RETIRED": "已停用",
      "QUEUED": "排队中",
      "SUBMITTING": "发送中",
      "ACCEPTED": "已接收",
      "PARTIALLY_ACCEPTED": "部分接收",
      "REJECTED": "被拒绝",
      "RETRY_PENDING": "待重试",
      "RECONCILIATION_REQUIRED": "需核对",
      "CANCELLED": "已取消",
      "PENDING": "待处理",
      "IGNORED": "已忽略"
    },
    "kpiCategory": {
      "OPERATIONS": "运营",
      "CLINICAL": "临床",
      "SURGERY": "手术",
      "EYE_HEALTH": "眼健康",
      "EPIDEMIOLOGY": "流行病学",
      "INPATIENT": "住院",
      "SUPPLIES": "物资",
      "DATA_QUALITY": "数据质量",
      "STAFF": "人员"
    },
    "kpiUnit": {
      "COUNT": "数量",
      "PERCENT": "百分比",
      "MINUTES": "分钟",
      "DAYS": "天",
      "RATIO": "比率"
    },
    "kpiDirection": {
      "HIGHER_BETTER": "越高越好",
      "LOWER_BETTER": "越低越好",
      "INFO": "仅供参考"
    },
    "dimension": {
      "SEX": "性别",
      "AGE_BAND": "年龄组",
      "MALE": "男",
      "FEMALE": "女",
      "AGE_0_14": "0–14 岁",
      "AGE_15_49": "15–49 岁",
      "AGE_50P": "50 岁及以上"
    },
    "dhis2Env": {
      "MOCK": "模拟器",
      "STAGING": "测试",
      "PRODUCTION": "生产"
    },
    "mappingType": {
      "ORG_UNIT": "组织单元",
      "DATA_SET": "数据集",
      "DATA_ELEMENT": "数据元",
      "CATEGORY_OPTION": "类别选项"
    },
    "valueTransform": {
      "NONE": "按计算值",
      "ROUND": "整数",
      "ONE_DECIMAL": "一位小数"
    },
    "metadataKind": {
      "ORG_UNIT": "组织单元",
      "DATA_SET": "数据集",
      "DATA_ELEMENT": "数据元",
      "CATEGORY_OPTION_COMBO": "类别组合",
      "ATTRIBUTE_OPTION_COMBO": "属性组合"
    },
    "tenantType": {
      "HEALTHCARE_GROUP": "医疗集团",
      "HOSPITAL": "医院",
      "CLINIC": "诊所",
      "GOVERNMENT": "政府",
      "NGO": "非政府组织"
    },
    "tenantStatus": {
      "ACTIVE": "启用",
      "SUSPENDED": "已暂停",
      "INACTIVE": "已停用"
    },
    "referralStatus": {
      "REQUESTED": "已申请",
      "SENT": "已发送",
      "ACCEPTED": "已接收",
      "DECLINED": "被拒绝",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消",
      "UNREACHABLE": "无法联系"
    },
    "referralDirection": {
      "OUT": "转出",
      "IN": "转入"
    },
    "referralPriority": {
      "ROUTINE": "常规",
      "URGENT": "紧急",
      "EMERGENCY": "急诊"
    },
    "referralTransport": {
      "SELF": "自行前往",
      "FAMILY": "家属陪同",
      "AMBULANCE": "救护车",
      "HOSPITAL_VEHICLE": "医院车辆",
      "OTHER": "其他"
    },
    "referralEvent": {
      "CREATED": "创建",
      "UPDATED": "修改",
      "SENT": "发送",
      "ACCEPTED": "接收",
      "DECLINED": "拒绝",
      "CONTACT_ATTEMPT": "联系",
      "UNREACHABLE": "无法联系",
      "COMPLETED": "完成",
      "CANCELLED": "取消"
    },
    "contactResult": {
      "REACHED": "已联系上",
      "NO_ANSWER": "无人接听",
      "WRONG_NUMBER": "号码错误",
      "LEFT_MESSAGE": "已留言"
    },
    "followUpPriority": {
      "ROUTINE": "常规",
      "URGENT": "紧急"
    },
    "mergeStatus": {
      "REQUESTED": "等待审批",
      "APPROVED": "已合并",
      "REJECTED": "已拒绝",
      "CANCELLED": "已取消"
    },
    "queuePriorityReason": {
      "ELDERLY": "老年人",
      "DISABILITY": "残障人士",
      "PREGNANT": "孕妇",
      "CHILD": "幼儿",
      "CLINICAL": "临床",
      "OTHER": "其他"
    },
    "queueStage": {
      "REGISTRATION": "登记",
      "TRIAGE": "分诊",
      "EXAMINATION": "检查",
      "CONSULTATION": "就诊",
      "DIAGNOSTICS": "辅助检查",
      "SURGERY": "手术",
      "PHARMACY": "药房",
      "CASHIER": "收费",
      "OTHER": "其他"
    },
    "queueSource": {
      "DESK": "服务台",
      "APPOINTMENT": "预约签到",
      "QR": "扫码签到",
      "KIOSK": "自助机",
      "MOBILE": "患者应用"
    },
    "queueEvent": {
      "ISSUED": "取号",
      "CALLED": "已叫号",
      "RECALLED": "重新叫号",
      "SERVING": "开始服务",
      "COMPLETED": "完成",
      "SKIPPED": "过号（不在场）",
      "REQUEUED": "重新排队",
      "RETURNED": "返回等候",
      "CANCELLED": "已取消",
      "TRANSFERRED": "转送",
      "PRIORITY_CHANGED": "优先级变更",
      "PATIENT_LINKED": "关联患者档案"
    },
    "queueActor": {
      "STAFF": "员工",
      "KIOSK": "自助机",
      "PATIENT_APP": "患者应用",
      "SYSTEM": "系统"
    },
    "queueVisitStatus": {
      "ACTIVE": "在院",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消"
    },
    "queueServiceStatus": {
      "ACTIVE": "使用中",
      "INACTIVE": "停用"
    }
  },
  "dashboard": {
    "title": "仪表盘",
    "welcome": "欢迎，{{name}}",
    "subtitle": "{{hospital}} · 今日",
    "patientsTotal": "在册患者",
    "registeredToday": "今日登记",
    "appointmentsToday": "今日预约",
    "queueWaiting": "排队等候",
    "avgWait": "平均等候时间",
    "openEncounters": "进行中的就诊",
    "pendingPrescriptions": "待发药处方",
    "pendingLabOrders": "待处理检验单",
    "revenueToday": "今日收入",
    "outstanding": "未结余额",
    "encountersTrend": "就诊量 · 近 7 天",
    "revenueTrend": "收入 · 近 7 天",
    "appointmentsByDepartment": "今日各科室预约",
    "minutes": "{{value}} 分钟",
    "noData": "暂无数据",
    "quickActions": "快捷操作"
  },
  "patients": {
    "title": "患者",
    "register": "登记患者",
    "searchPlaceholder": "按姓名、病历号、电话或身份证号搜索",
    "mrn": "病历号",
    "name": "姓名",
    "firstName": "名",
    "middleName": "中间名",
    "lastName": "姓",
    "preferredName": "常用名",
    "dateOfBirth": "出生日期",
    "age": "年龄",
    "sex": "性别",
    "bloodGroup": "血型",
    "maritalStatus": "婚姻状况",
    "occupation": "职业",
    "nationality": "国籍",
    "phone": "电话",
    "email": "邮箱",
    "address": "地址",
    "emergencyContactName": "紧急联系人",
    "emergencyContactPhone": "紧急联系人电话",
    "nationalId": "身份证号",
    "preferredLanguage": "首选语言",
    "identifiers": "证件",
    "identifierType": "证件类型",
    "identifierValue": "证件号码",
    "addIdentifier": "添加证件",
    "registeredOn": "登记时间",
    "sectionPersonal": "个人信息",
    "sectionContact": "联系方式",
    "sectionEmergency": "紧急联系人",
    "sectionIdentifiers": "证件",
    "created": "患者 {{mrn}} 已登记",
    "updated": "患者档案已更新",
    "editTitle": "编辑患者",
    "duplicateTitle": "可能为重复患者",
    "duplicateMessage": "以下现有档案与之相似。请打开查看，或确认是不同的人。",
    "duplicateConfirm": "不是同一人 — 继续登记",
    "identifierMatchTitle": "该证件已登记",
    "matchReason": {
      "NAME_AND_BIRTH_DATE": "姓名和出生日期相同",
      "PHONE_AND_FIRST_NAME": "电话和名字相同"
    },
    "allergies": "过敏",
    "noKnownAllergies": "无已知过敏",
    "addAllergy": "添加过敏",
    "allergen": "过敏原",
    "reaction": "过敏反应",
    "severity": "严重程度",
    "onsetDate": "发生日期",
    "alerts": "警示",
    "addAlert": "添加警示",
    "alertType": "警示类型",
    "alertMessage": "内容",
    "tabOverview": "概览",
    "tabEncounters": "就诊记录",
    "tabAppointments": "预约",
    "tabPrescriptions": "处方",
    "tabLabs": "检验结果",
    "tabInvoices": "账单",
    "newEncounter": "开始就诊",
    "bookAppointment": "预约",
    "addToQueue": "加入排队",
    "empty": "没有符合条件的患者。",
    "pickerPlaceholder": "按姓名或病历号搜索患者",
    "sectionPhoto": "照片",
    "sectionAddress": "地址",
    "province": "省",
    "district": "县",
    "subdistrict": "乡/片区",
    "village": "村",
    "addressLine": "门牌 / 街道",
    "addressLineHint": "可选：门牌号、组、街道或地标",
    "chooseProvinceFirst": "请先选择省",
    "chooseDistrictFirst": "请先选择县",
    "noSubdistricts": "未设置乡/片区",
    "disability": "残疾情况",
    "takePhoto": "拍照",
    "choosePhoto": "选择照片",
    "undoPhoto": "撤销",
    "removePhoto": "删除照片",
    "photoHint": "JPEG、PNG 或 WebP，系统会自动缩放。",
    "photoInvalid": "该文件不是受支持的图片",
    "nameTitle": "称谓",
    "noTitle": "— 无称谓 —",
    "titleSuggested": "根据性别和年龄建议",
    "disabilityDetails": "残疾详情"
  },
  "appointments": {
    "title": "预约",
    "book": "新建预约",
    "date": "日期",
    "start": "开始",
    "end": "结束",
    "time": "时间",
    "practitioner": "医生",
    "department": "科室",
    "type": "就诊类型",
    "reason": "就诊原因",
    "notes": "备注",
    "patient": "患者",
    "anyPractitioner": "全部医生",
    "anyDepartment": "全部科室",
    "checkIn": "签到",
    "confirm": "确认",
    "cancel": "取消预约",
    "noShow": "爽约",
    "startEncounter": "开始就诊",
    "openEncounter": "打开就诊",
    "booked": "预约 {{number}} 已创建",
    "checkedIn": "已签到 — 排队号 {{ticket}}",
    "cancelled": "预约已取消",
    "empty": "当天没有预约。",
    "priority": "优先级",
    "number": "编号"
  },
  "queue": {
    "title": "排队",
    "department": "科室",
    "selectDepartment": "选择科室",
    "callNext": "叫下一位",
    "counter": "窗口 / 诊室",
    "waiting": "等候中",
    "inService": "已叫号 / 服务中",
    "served": "已服务",
    "ticket": "排队号",
    "issuedAt": "取号时间",
    "recall": "重新叫号",
    "startService": "开始服务",
    "complete": "完成",
    "skip": "过号",
    "requeue": "重新排队",
    "cancelTicket": "取消排队号",
    "walkIn": "现场取号",
    "display": "叫号屏",
    "nowServing": "正在服务",
    "nextUp": "下一位",
    "empty": "暂无等候。",
    "calling": "请 {{ticket}} 号就诊",
    "waitMinutes": "{{value}} 分钟",
    "scanQr": "扫描患者二维码",
    "estimatedWait": "新患者预计等候",
    "min": "分钟",
    "fromApp": "应用取号",
    "loadDetail": "{{counters}} 个窗口 · 平均等候 {{avg}} 分钟 · 最长 {{longest}} 分钟",
    "open": "开放",
    "pause": "暂停应用取号",
    "pauseHelp": "停止应用取号，窗口仍可发号",
    "close": "关闭",
    "source": {
      "MOBILE": "来自患者应用",
      "QR": "扫码签到",
      "KIOSK": "来自自助机"
    },
    "subtitle": "在您的服务点叫号、重呼、过号、转送并完成患者服务",
    "kioskOpen": "自助机",
    "report": "等候时间",
    "servicePoint": "服务点",
    "selectService": "选择服务点",
    "allServices": "所有服务点",
    "stage": "环节",
    "priorityWaiting": "优先等候",
    "nobodyCalled": "尚未叫号。请点击“叫下一位”。",
    "skipped": "过号",
    "noSkipped": "没有过号的号码。",
    "done": "已完成",
    "noneDone": "尚无完成的患者。",
    "waitingTimes": "等候时间报表",
    "notRegistered": "尚未登记",
    "assistanceRequested": "在自助机请求帮助",
    "priorityRequested": "申请优先：{{reason}}",
    "hasDisability": "有残障记录",
    "age": "{{value}} 岁",
    "sinceCalled": "自叫号 / 开始服务以来的时间",
    "waited": "已等 {{value}} 分钟",
    "recalled": "重呼 {{value}} 次",
    "findOrRegister": "查找或登记患者",
    "openEncounter": "打开就诊",
    "transfer": "转送",
    "backToQueue": "返回等候",
    "backToQueueHelp": "让患者回到等候列表（如等待眼药水起效），保留原顺序",
    "call": "叫号",
    "callThis": "立即叫此号（插队）",
    "priority": "优先级",
    "cancelTitle": "取消号码 {{ticket}}？",
    "cancelHelp": "该号码将关闭，患者离开队列。此操作保留在排队记录中。",
    "cancelReason": "原因",
    "transferredIn": "来自其他队列",
    "setPriority": "{{ticket}} 的优先级",
    "priorityHelp": {
      "NORMAL": "按到达顺序",
      "PRIORITY": "老年人、残障人士、孕妇、幼儿",
      "URGENT": "临床：优先于他人",
      "EMERGENCY": "临床：立即处理"
    },
    "triageOnly": "紧急和急诊优先级由临床人员设置。",
    "priorityReason": "优先原因",
    "note": "备注",
    "transferTitle": "转送 {{ticket}}",
    "transferHelp": "患者保持同一号码并进入所选队列。",
    "registerFirst": "该患者尚未登记。请先登记或查找患者；在此之前只能转到登记处。",
    "waitingCount": "{{value}} 人等候",
    "handoverNote": "给下一服务点的备注",
    "handoverNoteHint": "如：10:15 已滴散瞳药",
    "transferred": "{{ticket}} 已转送至 {{service}}",
    "linkPatientTitle": "号码 {{ticket}} 的患者",
    "linkPatientHelp": "查找患者档案，或登记新患者（在新标签页打开）后在此查找。",
    "findPatient": "患者",
    "registerNew": "登记新患者",
    "linkPatient": "关联到号码",
    "patientLinked": "已将患者关联到号码",
    "history": "排队记录",
    "historyTitle": "{{ticket}} 的排队记录",
    "patient": "患者",
    "visitStatus": "来院",
    "timeInHospital": "在院时间",
    "encounter": "就诊",
    "noHistory": "暂无记录。",
    "displaySetup": "设置此显示屏",
    "displaySetupHelp": "选择此屏幕显示的服务点。屏幕地址会保存选择，请在显示屏浏览器中添加书签。",
    "openDisplay": "打开显示屏",
    "displayTitle": "叫号",
    "nowCalling": "正在叫号",
    "pleaseWait": "请等候您的号码",
    "missed": "已过号：请到服务台",
    "displayFooter": "您的号码在整个就诊过程中保持不变。请保留您的号票。",
    "soundOn": "打开语音播报",
    "soundOff": "关闭语音播报",
    "fullscreen": "全屏",
    "tapForSound": "点击打开声音",
    "announce": "请 {{ticket}} 号到 {{counter}}，{{service}}",
    "rep": {
      "title": "排队等候时间",
      "subtitle": "根据排队记录，按服务点统计等候和服务时间",
      "today": "今天",
      "week": "7 天",
      "month": "30 天",
      "noData": "此期间没有排队号码。",
      "avgWait": "平均等候",
      "medianWait": "等候中位数",
      "p90Wait": "90% 在此时间内被叫",
      "p90Hint": "十分之九的患者等候少于此时间",
      "maxWait": "最长等候",
      "waitHint": "从进入队列到首次叫号",
      "avgService": "平均服务时间",
      "avgVisit": "平均来院时长",
      "visitsCompleted": "{{total}} 次来院中完成 {{value}} 次",
      "tickets": "号码数",
      "ticketsHint": "已服务 {{served}} · 转送 {{transferred}}",
      "missed": "过号（不在场）",
      "cancelled": "已取消 {{value}}",
      "kiosk": "自助机来院",
      "kioskHint": "服务台登记 {{registered}} · 请求帮助 {{help}}",
      "byHour": "按小时统计到达人数",
      "arrivals": "到达 {{value}} 人",
      "avgWaitShort": "平均等候 {{value}} 分钟",
      "bySourcePriority": "按来源和优先级",
      "byService": "按服务点",
      "transferredOn": "转送",
      "byDay": "按日期"
    },
    "kiosk": {
      "title": "自助签到",
      "welcome": "欢迎。今天我们能为您做什么？",
      "haveAppointment": "我今天有预约",
      "haveAppointmentHint": "签到并领取排队号",
      "registeredWalkIn": "我是本院患者，没有预约",
      "registeredWalkInHint": "领取服务号码",
      "newOrHelp": "新患者，或我需要帮助",
      "newOrHelpHint": "领取登记处号码",
      "emergencyNote": "紧急情况？请直接前往急诊科或告知工作人员。",
      "identifyTitle": "查找您的档案",
      "mrnOrPhone": "病历号（HN）或电话号码",
      "birthDate": "出生日期",
      "day": "日",
      "month": "月",
      "year": "年",
      "delete": "删除",
      "privacy": "这些信息仅用于查找您的档案，屏幕上不会显示个人信息。",
      "continue": "继续",
      "hello": "您好，{{name}}。",
      "noAppointment": "未找到您今天的预约。",
      "takeWalkIn": "领取服务号码",
      "checkIn": "签到",
      "chooseService": "您要去哪里？",
      "waitInfo": "{{waiting}} 人等候 · 约 {{minutes}} 分钟",
      "priorityQuestion": "您需要优先服务吗？",
      "priorityHint": "工作人员叫号时会确认优先资格。",
      "request": {
        "ELDERLY": "60 岁及以上",
        "DISABILITY": "残障人士",
        "PREGNANT": "孕妇",
        "CHILD": "携带幼儿"
      },
      "notSure": "不确定去哪里？领取登记处号码",
      "helpTitle": "登记处",
      "helpText": "登记处工作人员会为您登记或提供帮助，然后引导您到正确的服务点。",
      "newPatientTicket": "我是新患者",
      "needHelpTicket": "我需要帮助",
      "registrationTicket": "领取登记处号码",
      "startOver": "重新开始",
      "yourNumber": "您的号码",
      "ahead": "前面还有 {{value}} 人 · 约 {{minutes}} 分钟",
      "slipNote": "请留意屏幕上的号码。整个就诊过程中号码不变。",
      "slipRegistration": "请等候叫号到登记处。",
      "alreadyQueued": "您今天已有号码，这是您的号码。",
      "print": "打印号票",
      "done": "完成",
      "error": {
        "NOT_FOUND": "根据这些信息未找到您的档案。",
        "TOO_MANY_REQUESTS": "尝试次数过多。请到登记处咨询。",
        "QUEUE_PAUSED": "该服务的自助签到已暂停。请到服务台咨询。",
        "QUEUE_CLOSED": "该服务今天已关闭。请到服务台咨询。",
        "NOT_TODAY": "该预约不是今天。",
        "INVALID_TRANSITION": "该预约无法在此签到。请到服务台咨询。",
        "NO_DEPARTMENT": "该预约无法在此签到。请到服务台咨询。",
        "OTHER": "出现问题。请到登记处咨询。"
      }
    }
  },
  "encounters": {
    "title": "就诊",
    "mine": "我的患者",
    "all": "全部",
    "today": "今天",
    "number": "就诊号",
    "type": "类型",
    "startedAt": "开始时间",
    "endedAt": "结束时间",
    "chiefComplaint": "主诉",
    "practitioner": "医生",
    "department": "科室",
    "complete": "结束就诊",
    "completeConfirm": "确定结束本次就诊？结束后记录和医嘱将变为只读。",
    "cancel": "取消就诊",
    "cancelReason": "取消原因",
    "started": "就诊 {{number}} 已开始",
    "completed": "就诊已结束",
    "vitals": "生命体征",
    "recordVitals": "记录生命体征",
    "temperature": "体温",
    "heartRate": "心率",
    "respiratoryRate": "呼吸频率",
    "bloodPressure": "血压",
    "systolic": "收缩压",
    "diastolic": "舒张压",
    "spo2": "血氧饱和度",
    "weight": "体重",
    "height": "身高",
    "bmi": "BMI",
    "painScore": "疼痛评分 (0–10)",
    "recordedAt": "记录时间",
    "recordedBy": "记录人",
    "unitCelsius": "°C",
    "unitBpm": "次/分",
    "unitPerMin": "/分",
    "unitMmHg": "mmHg",
    "unitPercent": "%",
    "unitKg": "kg",
    "unitCm": "cm",
    "diagnoses": "诊断",
    "addDiagnosis": "添加诊断",
    "diagnosisCode": "ICD-10 编码",
    "diagnosisDescription": "诊断名称",
    "diagnosisType": "诊断类型",
    "verification": "核实状态",
    "markEnteredInError": "标记为录入错误",
    "notes": "病历记录",
    "newNote": "新建记录",
    "noteType": "记录类型",
    "content": "内容",
    "saveDraft": "保存草稿",
    "saveAndSign": "保存并签署",
    "sign": "签署",
    "amend": "修订",
    "amendReason": "修订原因",
    "amendmentOf": "对之前记录的修订",
    "signedBy": "{{name}} 签署 · {{time}}",
    "draftBy": "{{name}} 的草稿",
    "prescriptions": "处方",
    "newPrescription": "开处方",
    "labOrders": "检验单",
    "newLabOrder": "开检验单",
    "noVitals": "尚未记录生命体征。",
    "noDiagnoses": "暂无诊断。",
    "noNotes": "暂无记录。",
    "noPrescriptions": "暂无处方。",
    "noLabOrders": "暂无检验单。",
    "closedBanner": "该就诊状态为{{status}}，仅可查看。",
    "start": "开始就诊",
    "empty": "未找到就诊记录。",
    "soapTemplate": "S（主观）：\nO（客观）：\nA（评估）：\nP（计划）："
  },
  "pharmacy": {
    "title": "药房",
    "worklist": "待发药",
    "history": "历史",
    "catalog": "药品目录",
    "prescription": "处方",
    "prescriptionNumber": "处方号",
    "prescriber": "开方医生",
    "issuedAt": "开具时间",
    "items": "药品",
    "medication": "药品",
    "selectMedication": "搜索药品",
    "dose": "剂量",
    "doseUnit": "单位",
    "frequency": "频次",
    "route": "给药途径",
    "duration": "疗程",
    "quantity": "数量",
    "instructions": "用法说明",
    "addItem": "添加药品",
    "removeItem": "移除",
    "issue": "签署并开具",
    "issued": "处方 {{number}} 已开具",
    "dispense": "发药",
    "dispenseAll": "发放全部剩余药品",
    "dispensed": "已发药",
    "dispensedQty": "已发",
    "remaining": "剩余",
    "cancelPrescription": "取消处方",
    "allergyWarningTitle": "过敏警告",
    "allergyWarningBody": "{{medication}} 与已记录的过敏原“{{allergen}}”（{{severity}}）相符。",
    "overrideAndIssue": "忽略警告并开具",
    "patientAllergies": "患者过敏史",
    "genericName": "通用名",
    "brandName": "商品名",
    "strength": "规格",
    "dosageForm": "剂型",
    "unitPrice": "单价",
    "manufacturer": "生产厂家",
    "newMedication": "新增药品",
    "editMedication": "编辑药品",
    "empty": "暂无待发药处方。"
  },
  "lab": {
    "title": "检验科",
    "worklist": "工作列表",
    "completed": "已完成",
    "order": "检验单",
    "orderNumber": "检验单号",
    "orderedBy": "开单人",
    "orderedAt": "开单时间",
    "priority": "优先级",
    "tests": "检验项目",
    "selectTests": "选择检验项目",
    "clinicalNotes": "临床信息",
    "placeOrder": "提交检验单",
    "orderPlaced": "检验单 {{number}} 已提交",
    "collect": "采集标本",
    "collected": "标本已采集",
    "specimen": "标本",
    "result": "结果",
    "value": "数值",
    "resultText": "结果描述",
    "flag": "标识",
    "unit": "单位",
    "referenceRange": "参考范围",
    "saveResult": "保存结果",
    "verify": "审核",
    "verified": "结果已审核",
    "correct": "更正结果",
    "correctionReason": "更正原因",
    "corrected": "结果已更正",
    "enteredBy": "录入人",
    "verifiedBy": "审核人",
    "cancelOrder": "取消检验单",
    "empty": "此列表中没有检验单。",
    "category": "类别",
    "price": "价格",
    "turnaround": "出报告时间",
    "awaitingResult": "等待结果"
  },
  "billing": {
    "title": "收费",
    "invoices": "账单",
    "newInvoice": "新建账单",
    "invoice": "账单",
    "invoiceNumber": "账单号",
    "patient": "患者",
    "encounter": "就诊",
    "items": "项目",
    "description": "项目名称",
    "quantity": "数量",
    "unitPrice": "单价",
    "discount": "折扣",
    "tax": "税额",
    "subtotal": "小计",
    "total": "合计",
    "paid": "已付",
    "balance": "余额",
    "issuedAt": "开具时间",
    "chargeItems": "服务与费用",
    "addCharge": "添加服务",
    "unbilledItems": "本次就诊未计费项目",
    "includeUnbilled": "包含未计费的药品和检验",
    "payments": "付款记录",
    "recordPayment": "登记付款",
    "amount": "金额",
    "method": "支付方式",
    "provider": "支付机构",
    "reference": "参考号",
    "paymentRecorded": "付款已登记",
    "payInFull": "全额支付",
    "void": "作废账单",
    "voidReason": "作废原因",
    "refund": "退款",
    "refundReason": "退款原因",
    "receipt": "收据",
    "printReceipt": "打印收据",
    "created": "账单 {{number}} 已创建",
    "pendingConfirmation": "等待支付机构确认",
    "outstanding": "未结清",
    "thankYou": "谢谢，祝您早日康复！",
    "selectEncounter": "就诊（可选）",
    "empty": "未找到账单。",
    "receivedBy": "收款人",
    "applyDiscount": "折扣",
    "discountHint": "折扣会连同您的姓名和原因一起记录，需要折扣权限。",
    "discountPreview": "折扣 {{discount}} · 新合计 {{total}}",
    "discountSaved": "折扣已保存",
    "lineDiscounts": "行折扣",
    "noDiscount": "不可打折",
    "billDiscount": "整单折扣"
  },
  "admin": {
    "usersTitle": "用户",
    "newUser": "新增用户",
    "editUser": "编辑用户",
    "username": "用户名",
    "fullName": "姓名",
    "email": "邮箱",
    "phone": "电话",
    "roles": "角色",
    "password": "初始密码",
    "resetPassword": "重置密码",
    "newPassword": "新密码",
    "disable": "停用",
    "enable": "启用",
    "lastLogin": "最近登录",
    "locked": "已锁定",
    "userCreated": "用户已创建",
    "isPractitioner": "该用户是医护人员",
    "employeeCode": "工号",
    "specialty": "专业",
    "licenseNumber": "执业证号",
    "departmentsTitle": "科室",
    "newDepartment": "新增科室",
    "departmentType": "科室类型",
    "practitionersTitle": "医护人员",
    "newPractitioner": "新增医护人员",
    "displayName": "显示名称",
    "department": "科室",
    "hospitalTitle": "医院设置",
    "hospitalName": "医院名称",
    "registrationNumber": "注册号",
    "timezone": "时区",
    "currency": "货币",
    "defaultLanguage": "默认语言",
    "organization": "机构",
    "auditTitle": "审计日志",
    "auditAction": "操作",
    "auditResource": "资源",
    "auditActor": "用户",
    "auditTime": "时间",
    "auditIp": "IP 地址",
    "auditChanges": "变更",
    "auditBefore": "变更前",
    "auditAfter": "变更后",
    "auditResourceId": "资源 ID",
    "hospitalDetails": "基本信息",
    "hospitalLocation": "位置",
    "addressDetails": "街道、楼宇及其他详情",
    "addressDetailsHint": "打印在信头的医院名称下方",
    "latitude": "纬度",
    "longitude": "经度",
    "latitudeHint": "介于 -90 和 90 之间；两项都填或都不填",
    "longitudeHint": "介于 -180 和 180 之间；两项都填或都不填",
    "openMap": "在地图中打开",
    "clearPosition": "清除坐标",
    "positionHint": "十进制度数，例如万象为 17.966000 和 102.600000。“使用我的位置”需在医院内的设备上使用。",
    "useMyLocation": "使用我的位置",
    "locateFailed": "无法读取此设备的位置",
    "hospitalPhoto": "医院照片和标志",
    "changePhoto": "更换照片",
    "uploadPhoto": "上传照片",
    "removePhoto": "删除照片",
    "photoHint": "JPEG、PNG 或 WebP。该图片将作为医院标志显示在菜单、登录页和打印文件上。最好使用正方形图片。",
    "noPhotoYet": "尚无照片：目前显示默认的 HMS 标志。",
    "removePhotoMessage": "将重新显示默认的 HMS 标志。",
    "photoSaved": "医院照片已保存",
    "photoRemoved": "医院照片已删除",
    "hospitalNameLo": "医院名称（老挝文）",
    "hospitalNameEn": "医院名称（英文）",
    "hospitalNameEnHint": "界面语言不是老挝语时以及在打印文件上显示"
  },
  "translations": {
    "title": "翻译",
    "subtitle": "自定义系统中的任何文字，修改后网页端和移动端立即生效。",
    "locale": "语言",
    "scope": "适用范围",
    "scopeUSER": "仅自己",
    "scopeHOSPITAL": "本医院",
    "scopeGLOBAL": "所有医院",
    "scopeHelpUSER": "仅您自己可见的个性化用语。",
    "scopeHelpHOSPITAL": "本医院所有人都会看到此用语。",
    "scopeHelpGLOBAL": "所有医院的默认用语（超级管理员）。",
    "key": "键",
    "reference": "英文参考",
    "baseValue": "默认文字",
    "override": "自定义文字",
    "effective": "当前显示",
    "searchPlaceholder": "搜索键或文字",
    "onlyCustomized": "仅已自定义",
    "onlyMissing": "此语言缺失",
    "resetKey": "恢复默认",
    "resetAll": "全部恢复默认",
    "resetAllConfirm": "删除此语言和范围下的所有自定义文字？",
    "importDone": "已导入 {{count}} 条翻译",
    "importInvalid": "该文件不是有效的翻译 JSON 文件。",
    "saveAll": "保存更改",
    "unsaved": "{{count}} 项未保存的更改",
    "stats": "已自定义 {{customized}} · 共 {{total}} 条",
    "missing": "缺失",
    "inheritedFrom": "来源：{{layer}}",
    "layerBundled": "内置",
    "saved": "翻译已保存"
  },
  "languages": {
    "title": "语言",
    "add": "添加语言",
    "code": "语言代码",
    "codeHelp": "ISO 代码，例如 km 或 zh-Hant",
    "name": "英文名称",
    "nativeName": "本地名称",
    "fallback": "回退语言",
    "enabled": "启用",
    "builtin": "内置",
    "custom": "自定义",
    "added": "语言已添加，请在翻译页面中翻译。"
  },
  "settings": {
    "title": "设置",
    "appearance": "外观",
    "theme": "主题",
    "themeHelp": "选择配色主题。“跟随系统”会根据设备的浅色或深色模式切换。",
    "accent": "强调色",
    "accentDefault": "主题默认",
    "density": "密度",
    "densityCompact": "紧凑",
    "densityComfortable": "舒适",
    "language": "语言",
    "languageHelp": "选择菜单和标签所使用的语言。",
    "account": "账号",
    "myTranslations": "我的用语",
    "myTranslationsHelp": "仅为自己修改界面文字，例如把“就诊”改为“看诊”。",
    "savedOnServer": "偏好设置保存在您的账号中，在移动端同样生效。"
  },
  "themes": {
    "system": "跟随系统",
    "clinical": "医疗蓝",
    "night": "夜间",
    "ocean": "海洋",
    "forest": "森林",
    "lotus": "莲花",
    "midnight": "午夜",
    "contrast": "高对比度",
    "gold": "金色",
    "oph": "OPH 眼科中心"
  },
  "notifications": {
    "title": "通知",
    "empty": "暂无新通知。",
    "markAllRead": "全部标为已读",
    "unread": "{{count}} 条未读",
    "prescriptionIssued": "新处方待发药：{{ref}}",
    "labOrdered": "新检验单：{{ref}}",
    "labResultVerified": "检验结果已出：{{ref}}",
    "patientCheckedIn": "患者已签到：{{ref}}",
    "highIop": "眼压过高：{{ref}}",
    "eyeSurgeryScheduled": "已安排眼科手术：{{ref}}",
    "lowStock": "库存不足",
    "prSubmitted": "待审批请购单",
    "prApproved": "您的请购单已批准",
    "prRejected": "您的请购单被驳回",
    "poApproval": "待审批采购订单",
    "stockDocSubmitted": "待审核库存单据：{{ref}}",
    "patientAdmitted": "患者入院：{{ref}}",
    "patientDischarged": "已出院，可结算：{{ref}}",
    "serviceOrdered": "新的特殊服务申请：{{ref}}",
    "serviceReported": "待审核报告：{{ref}}",
    "serviceVerified": "报告已出：{{ref}}",
    "expenseSubmitted": "待审批费用：{{ref}}",
    "cashSessionClosed": "待核对收银班次：{{ref}}",
    "posRefillSubmitted": "待备货的 POS 补货：{{ref}}",
    "posRefillSent": "POS 补货运送中 — 请确认收货：{{ref}}"
  },
  "time": {
    "justNow": "刚刚",
    "minutesAgo": "{{count}} 分钟前",
    "hoursAgo": "{{count}} 小时前",
    "daysAgo": "{{count}} 天前"
  },
  "mobile": {
    "serverUrl": "服务器地址",
    "serverUrlHelp": "HMS 服务器地址，例如 https://hms.example.org 或 http://192.168.1.10:8090"
  },
  "months": {
    "1": "1月",
    "2": "2月",
    "3": "3月",
    "4": "4月",
    "5": "5月",
    "6": "6月",
    "7": "7月",
    "8": "8月",
    "9": "9月",
    "10": "10月",
    "11": "11月",
    "12": "12月"
  },
  "analytics": {
    "title": "数据分析",
    "year": "年份",
    "today": "今日",
    "periodYtd": "{{from}} – {{to}}，对比{{prevYear}}年同期",
    "periodFull": "{{year}}全年对比{{prevYear}}年",
    "netRevenue": "净收入",
    "collected": "已收款",
    "collectionRate": "回款率 {{value}}",
    "visits": "就诊人次",
    "newPatients": "新患者",
    "revenuePerVisit": "次均收入",
    "vsLastYear": "同比",
    "noPrevious": "无上年数据",
    "revenueByCategory": "按服务类别收入",
    "paymentMethods": "按支付方式收款",
    "waterfall": "从收费到回款",
    "gross": "应收总额",
    "discounts": "折扣",
    "outstanding": "未收款",
    "net": "净收入",
    "revenueByMonth": "月度净收入",
    "revenueByQuarter": "季度收入",
    "revenueByMonthCategory": "按月及服务类别收入",
    "revenueByDepartment": "按科室收入",
    "statement": "收入表",
    "item": "项目",
    "change": "变化",
    "changePct": "变化 %",
    "sectionRevenue": "收入",
    "totalGross": "总收入",
    "sectionOperations": "运营",
    "invoices": "账单数",
    "visitsByMonth": "月度就诊人次",
    "topDiagnoses": "常见诊断",
    "demographics": "就诊患者年龄与性别分布",
    "quarter": "第{{n}}季度",
    "noData": "该期间暂无数据",
    "category": {
      "CONSULTATION": "诊疗",
      "PHARMACY": "药品",
      "LABORATORY": "检验",
      "PROCEDURE": "操作",
      "SERVICE": "急诊与服务",
      "ADMINISTRATIVE": "行政",
      "OTHER": "其他",
      "OPHTHALMOLOGY": "眼科",
      "SPECIAL_SERVICES": "特殊服务",
      "INPATIENT": "住院床位",
      "POS_SALES": "柜台销售"
    }
  },
  "eye": {
    "title": "眼科中心",
    "subtitle": "眼科：检查、手术、注射与随访",
    "overview": "概览",
    "eyeRecord": "眼科病历",
    "generalRecord": "综合病历",
    "openPatientRecord": "打开患者眼科病历",
    "patient": "患者",
    "eyeSide": "眼别",
    "eyes": "眼",
    "side": {
      "OD": "右眼 (OD)",
      "OS": "左眼 (OS)",
      "OU": "双眼 (OU)"
    },
    "examinations": "检查",
    "surgeries": "手术",
    "injections": "玻璃体注射",
    "followUps": "随访",
    "medications": "眼科用药",
    "imaging": "影像检查",
    "procedures": "操作",
    "biometryIol": "生物测量与人工晶状体",
    "trends": "趋势",
    "currentStatus": "当前状态（各眼最新）",
    "newExam": "新建眼科检查",
    "startEyeExam": "开始眼科检查",
    "openEyeExam": "眼科检查",
    "useOpenEncounter": "在进行中的就诊中继续：",
    "startWithNewEncounter": "新建就诊并开始",
    "planSurgery": "计划手术",
    "injection": "注射",
    "followUp": "随访",
    "recordInjection": "记录玻璃体腔注射",
    "prescribeDrops": "开具滴眼液",
    "scheduleFollowUp": "安排随访",
    "visualAcuity": "视力",
    "iop": "眼压 (IOP)",
    "refraction": "验光",
    "slitLamp": "裂隙灯检查",
    "fundus": "眼底检查",
    "diagnoses": "眼科诊断",
    "historyAndPlan": "病史、记录与计划",
    "addVisualAcuity": "记录视力",
    "addPressure": "记录眼压",
    "addRefraction": "记录验光",
    "addDiagnosis": "添加眼科诊断",
    "measurementType": "测量方式",
    "chartType": "视力表",
    "acuity": "视力",
    "acuityHint": "Snellen（6/12、20/40）、小数、logMAR、CF、HM、LP、NLP",
    "correction": "矫正方式",
    "correctionPlaceholder": "如：框架眼镜、隐形眼镜",
    "pressure": "眼压",
    "method": "方法",
    "measuredAt": "测量时间",
    "refractionType": "类型",
    "sphere": "球镜",
    "cylinder": "柱镜",
    "axis": "轴位",
    "add": "下加光",
    "pd": "瞳距 (PD)",
    "acuityWithRx": "此处方矫正视力",
    "vaType": {
      "UNAIDED": "裸眼",
      "CORRECTED": "戴镜",
      "PINHOLE": "针孔",
      "BEST_CORRECTED": "最佳矫正视力 (BCVA)",
      "NEAR": "近视力"
    },
    "chart": {
      "SNELLEN": "Snellen 视力表",
      "LOGMAR": "LogMAR",
      "DECIMAL": "小数视力",
      "TUMBLING_E": "E 字视力表",
      "LEA": "LEA 图形",
      "JAEGER": "Jaeger（近）",
      "OTHER": "其他"
    },
    "refractionTypes": {
      "AUTO": "电脑验光",
      "RETINOSCOPY": "视网膜检影",
      "SUBJECTIVE": "主觉验光",
      "FINAL_PRESCRIPTION": "最终处方"
    },
    "iopMethod": {
      "GOLDMANN": "Goldmann 压平眼压计",
      "NON_CONTACT": "非接触（气流）",
      "TONOPEN": "Tono-Pen",
      "REBOUND": "回弹式 (iCare)",
      "OTHER": "其他"
    },
    "iopLevel": {
      "LOW": "偏低",
      "NORMAL": "正常",
      "ELEVATED": "偏高",
      "CRITICAL": "危急"
    },
    "dxType": {
      "PRIMARY": "主要",
      "SECONDARY": "次要",
      "DIFFERENTIAL": "鉴别",
      "COMPLICATION": "并发症"
    },
    "severity": "严重程度",
    "severities": {
      "MILD": "轻度",
      "MODERATE": "中度",
      "SEVERE": "重度",
      "EARLY": "早期",
      "ADVANCED": "进展期",
      "END_STAGE": "终末期",
      "NON_PROLIFERATIVE": "非增殖期",
      "PROLIFERATIVE": "增殖期"
    },
    "icdCode": "ICD-10 编码",
    "diagnosis": "诊断",
    "dx": {
      "H25_1": "年龄相关性核性白内障",
      "H26_9": "白内障，未特指",
      "H40_1": "原发性开角型青光眼",
      "H40_2": "原发性闭角型青光眼",
      "E11_3": "糖尿病视网膜病变",
      "H35_3": "年龄相关性黄斑变性",
      "H33_0": "孔源性视网膜脱离",
      "H34_8": "视网膜静脉阻塞",
      "H10_0": "急性细菌性结膜炎",
      "H16_0": "角膜溃疡",
      "H11_0": "翼状胬肉",
      "H04_1": "干眼症",
      "H52_1": "近视",
      "H52_0": "远视",
      "H52_4": "老视",
      "H50_0": "内斜视",
      "H53_0": "弱视",
      "H20_0": "急性前葡萄膜炎",
      "H00_0": "睑腺炎（麦粒肿）",
      "H57_1": "眼痛"
    },
    "field": {
      "chiefComplaint": "主诉",
      "historyOfPresentIllness": "现病史",
      "pastOcularHistory": "既往眼病史",
      "familyOcularHistory": "眼病家族史",
      "systemicHistory": "全身病史",
      "clinicalNotes": "临床记录",
      "plan": "处理计划",
      "lids": "眼睑",
      "lashes": "睫毛",
      "conjunctiva": "结膜",
      "sclera": "巩膜",
      "cornea": "角膜",
      "anteriorChamber": "前房",
      "iris": "虹膜",
      "pupil": "瞳孔",
      "lens": "晶状体",
      "vitreous": "玻璃体",
      "opticDisc": "视盘",
      "cupDiscRatio": "杯盘比 (C/D)",
      "macula": "黄斑",
      "vessels": "血管",
      "retina": "视网膜",
      "peripheralRetina": "周边视网膜",
      "notes": "备注"
    },
    "fillNormal": "填入正常所见",
    "notRecorded": "未记录",
    "noDiagnoses": "暂无眼科诊断",
    "cdrSuspicious": "C/D ≥ 0.6 可疑青光眼",
    "worse": "下降",
    "better": "改善",
    "previousValue": "上次：{{value}}",
    "sign": "签署检查",
    "signConfirm": "签署后检查将被锁定，之后的更正需以修订形式进行。现在签署吗？",
    "signed": "检查已签署",
    "amend": "修订",
    "amendHelp": "系统将创建已签署检查的副本用于更正，原记录保持不变。",
    "amendReason": "修订原因",
    "amendmentOf": "本记录是对以下检查的修订：",
    "originalExam": "原始检查",
    "supersededBy": "该检查已被修订，请查看",
    "latestAmendment": "最新修订",
    "signedBanner": "由 {{name}} 于 {{date}} 签署",
    "comparedWith": "与 {{date}} 的上次检查对比",
    "cancelExam": "取消检查",
    "logmarHelp": "LogMAR：0.0 = 6/6（20/20），0.3 = 6/12，1.0 = 6/60。数值越低越好；纵轴已反转，向上表示改善。",
    "drivingStandard": "6/12（驾驶标准）",
    "iopUpperNormal": "21 mmHg 正常上限",
    "cstThreshold": "300 µm",
    "mdModerate": "−6 dB",
    "centralThickness": "中心子区厚度",
    "rnfl": "视网膜神经纤维层厚度",
    "sphericalEquivalent": "等效球镜",
    "visualField": "视野",
    "noTrendData": "暂无数据",
    "treatments": "治疗",
    "bcva": "最佳矫正视力",
    "frequencies": {
      "qd": "每日一次",
      "bid": "每日两次",
      "tid": "每日三次",
      "qid": "每日四次",
      "q2h": "每2小时一次",
      "qhs": "每晚睡前一次"
    },
    "medication": "药品",
    "medicationName": "药品名称",
    "otherMedication": "其他（输入名称）",
    "dose": "剂量",
    "frequency": "频次",
    "duration": "疗程",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "instructions": "用药说明",
    "stop": "停用",
    "stopMedication": "停用眼科用药",
    "noMedications": "暂无眼科用药",
    "lotNumber": "批号",
    "expiryDate": "有效期",
    "indication": "适应证",
    "complications": "并发症",
    "confirmEyeStatement": "我已与患者及标记部位核对{{eye}}，并核对药品、剂量和有效期。",
    "noInjections": "暂无注射记录",
    "by": "执行者",
    "modality": "检查类型",
    "results": "结果",
    "device": "设备",
    "noImaging": "暂无影像检查",
    "modalities": {
      "FUNDUS_PHOTO": "眼底照相",
      "OCT": "OCT",
      "OCT_ANGIOGRAPHY": "OCT 血管成像",
      "VISUAL_FIELD": "视野",
      "CORNEAL_TOPOGRAPHY": "角膜地形图",
      "PACHYMETRY": "角膜测厚",
      "B_SCAN": "B 超",
      "BIOMETRY": "生物测量",
      "OTHER": "其他"
    },
    "procedure": "手术/操作",
    "outcome": "结果",
    "noExams": "暂无眼科检查",
    "noSurgeries": "暂无眼科手术",
    "noFollowUps": "暂无随访",
    "postOp": "术后复查",
    "caseNumber": "手术编号",
    "biometry": "生物测量",
    "biometryHelp": "各眼光学生物测量。选择一次测量以规划人工晶状体。",
    "addBiometry": "添加生物测量",
    "noBiometry": "暂无生物测量",
    "axialLength": "眼轴长度",
    "lensThickness": "晶状体厚度",
    "axialAsymmetry": "双眼眼轴相差 {{diff}} mm，选择晶状体前请复测。",
    "toricHint": "角膜散光 {{cyl}} D，可考虑散光矫正型 (Toric) 晶状体。",
    "formula": "公式",
    "formulas": {
      "SRK_T": "SRK/T",
      "BARRETT_UNIVERSAL_II": "Barrett Universal II",
      "HAIGIS": "Haigis",
      "HOFFER_Q": "Hoffer Q",
      "HOLLADAY": "Holladay",
      "KANE": "Kane",
      "OTHER": "其他"
    },
    "aConstant": "A 常数",
    "targetRefraction": "目标屈光度",
    "iolModel": "晶状体型号",
    "iolPower": "晶状体度数",
    "iolPowerAuto": "留空则使用推荐度数",
    "fromBiometer": "取自生物测量仪报告",
    "predictedRefraction": "预测屈光度",
    "saveCalculation": "保存计算",
    "suggestedPower": "推荐晶状体度数",
    "emmetropicPower": "正视度数",
    "noCalculations": "暂无晶状体计算",
    "selected": "已选择",
    "select": "选择",
    "iolSelected": "已选定手术用晶状体",
    "operativeEye": "手术眼",
    "surgeryType": "手术类型",
    "surgeryTypes": {
      "CATARACT": "白内障",
      "GLAUCOMA": "青光眼",
      "RETINA": "视网膜",
      "VITRECTOMY": "玻璃体切除",
      "CORNEA": "角膜",
      "REFRACTIVE": "屈光手术",
      "OCULOPLASTIC": "眼整形",
      "STRABISMUS": "斜视",
      "PTERYGIUM": "翼状胬肉",
      "LASER": "激光",
      "OTHER": "其他"
    },
    "procedureExample": {
      "CATARACT": "超声乳化 + 人工晶状体植入",
      "GLAUCOMA": "小梁切除术",
      "RETINA": "巩膜扣带术",
      "VITRECTOMY": "经睫状体平坦部玻璃体切除",
      "CORNEA": "穿透性角膜移植",
      "REFRACTIVE": "LASIK",
      "OCULOPLASTIC": "眼睑成形术",
      "STRABISMUS": "内直肌后徙术",
      "PTERYGIUM": "切除联合自体结膜移植",
      "LASER": "YAG 激光后囊切开",
      "OTHER": "描述手术"
    },
    "anesthesia": "麻醉",
    "anesthesiaTypes": {
      "TOPICAL": "表面麻醉",
      "LOCAL": "局部麻醉",
      "PERIBULBAR": "球周麻醉",
      "RETROBULBAR": "球后麻醉",
      "SUB_TENON": "Tenon 囊下麻醉",
      "GENERAL": "全身麻醉"
    },
    "scheduledAt": "预约时间",
    "preopDiagnosis": "术前诊断",
    "noBiometryForEye": "该眼暂无生物测量",
    "chooseEyeFirst": "请先选择眼别",
    "cataractNeedsBiometry": "白内障手术在术前核查前需完成该眼生物测量并选定晶状体。",
    "safetyChecklist": "术前安全核查",
    "checklistHelp": "在患者清醒且团队在场时完成。眼别由团队口头确认，不从计划中复制。",
    "teamStatesEye": "团队确认的眼别",
    "eyeMismatchTitle": "眼别错误！",
    "eyeMismatchBody": "计划为{{planned}}，但团队确认的是{{stated}}。请停止并核实。",
    "check": {
      "patientIdentityConfirmed": "已核对患者身份（姓名 + 出生日期）",
      "procedureConfirmed": "已与患者及同意书核对手术",
      "eyeSideConfirmed": "已确认手术眼",
      "consentConfirmed": "已签署知情同意书",
      "siteMarked": "已标记手术部位"
    },
    "confirmChecklist": "确认核查",
    "checklistConfirmed": "安全核查已确认",
    "confirmedBy": "由 {{name}} 于 {{date}} 确认",
    "startSurgery": "开始手术",
    "startConfirm": "开始在{{eye}}进行{{procedure}}？",
    "cancelSurgery": "取消手术",
    "cancelledBecause": "已取消：{{reason}}",
    "surgicalPlan": "手术计划",
    "surgeon": "术者",
    "startedAt": "开始时间",
    "completedAt": "完成时间",
    "lensPlan": "晶状体方案",
    "openBiometry": "打开生物测量",
    "noBiometryLinked": "未关联生物测量",
    "selectedLens": "已选晶状体",
    "noLensSelected": "尚未选择晶状体",
    "operativeRecord": "手术记录",
    "operativeFindings": "术中所见",
    "operativeNotes": "手术经过",
    "postopNotes": "术后医嘱",
    "noneIfBlank": "无则留空",
    "implants": "植入物",
    "implantTypes": {
      "IOL": "人工晶状体",
      "CAPSULAR_TENSION_RING": "囊袋张力环",
      "GLAUCOMA_DRAINAGE_DEVICE": "青光眼引流装置",
      "STENT": "支架",
      "SILICONE_OIL": "硅油",
      "GAS": "气体填充",
      "OTHER": "其他"
    },
    "model": "型号",
    "manufacturer": "生产商",
    "serialNumber": "序列号",
    "powerMismatchTitle": "晶状体度数与计划不符。",
    "powerMismatchBody": "所选晶状体为 {{planned}} D，请核对晶状体包装与计划。",
    "powerOverride": "我已与术者核实此度数（记录为例外）",
    "firstPostOpVisit": "首次术后复查",
    "completeSurgery": "完成手术",
    "surgeryCompleted": "手术已完成",
    "followUpDate": "随访日期",
    "inDays": "{{count}} 天后",
    "examsToday": "今日检查",
    "openExams": "未完成检查",
    "surgeriesUpcoming": "待进行手术",
    "surgeriesMonth": "本月手术",
    "injectionsMonth": "本月注射",
    "followUpsToday": "今日随访",
    "followUpsOverdue": "逾期随访",
    "highIopPatients": "眼压 > 21 的患者",
    "activityByMonth": "眼科工作量（最近12个完整月）",
    "activity": {
      "exams": "检查",
      "injections": "注射",
      "surgeries": "手术"
    },
    "surgeriesByType": "各类手术（最近12个完整月）",
    "topEyeDiagnoses": "常见眼科诊断（12个月）",
    "iopControl": "眼压控制（各眼最新，12个月）",
    "iopControlHelp": "正常 10–21 mmHg。偏高和危急的眼需复查。",
    "cataractOutcome": "白内障手术效果",
    "cataractOutcomeHelp": "{{measured}} 只已测眼中有 {{good}} 只在 90 天内达到 6/12 或更好（12 个月内手术 {{operated}} 例）。",
    "upcomingSurgeries": "即将进行的手术",
    "anyDate": "任意日期",
    "myCases": "我的手术",
    "due": {
      "overdue": "已逾期",
      "today": "今天",
      "week": "未来7天"
    },
    "phone": "电话",
    "doctor": "医生",
    "markSeen": "已就诊",
    "markMissed": "失约"
  },
  "pathways": {
    "title": "治疗周期",
    "subtitle": "各疾病的分步治疗周期，供医生、护士和患者使用",
    "cycles": "周期",
    "dueReviews": "待复查",
    "new": "新建治疗周期",
    "searchPlaceholder": "搜索疾病、编码或周期…",
    "categoryLabel": "类别",
    "category": {
      "EYE": "眼科",
      "CHRONIC": "慢性病",
      "INFECTIOUS": "传染病",
      "MATERNAL": "母婴",
      "SURGICAL": "外科",
      "PEDIATRIC": "儿科",
      "MENTAL": "心理健康",
      "GENERAL": "综合"
    },
    "shared": "共享",
    "sharedTemplate": "共享模板",
    "sharedReadOnly": "这是共享模板。复制到本院后可调整阶段。",
    "hospital": "本院",
    "scope": "范围",
    "cyclic": "循环周期",
    "linear": "单向路径",
    "stageCount": "{{count}} 个阶段",
    "activePatients": "当前患者 {{count}}",
    "disease": "疾病",
    "diseaseCode": "ICD-10 编码",
    "stages": "阶段",
    "stage": "阶段",
    "patients": "患者",
    "pathway": "治疗周期",
    "currentStage": "当前阶段",
    "cycle": "轮次",
    "cycleN": "第 {{n}} 轮",
    "daysShort": "{{count}} 天",
    "nextReview": "下次复查",
    "nextReviewHint": "留空则按阶段时长计算",
    "nextReviewOn": "复查 {{date}}",
    "dueToday": "今天",
    "dueWeek": "7天内",
    "dueMonth": "30天内",
    "noneDue": "无待复查",
    "details": "详情",
    "autoCode": "留空自动生成",
    "color": "颜色",
    "inherit": "同周期",
    "isCyclicHelp": "循环：最后阶段后进入下一轮",
    "translations": "其他语言",
    "addStage": "添加阶段",
    "untitled": "未命名",
    "moveUp": "上移",
    "moveDown": "下移",
    "stageName": "阶段名称",
    "durationDays": "时长（天）",
    "icon": "图标",
    "actions": "团队工作",
    "actionsHint": "本阶段医护核对清单",
    "patientInstructions": "给患者的说明",
    "patientInstructionsHint": "在患者应用中显示",
    "preview": "预览",
    "previewCyclic": "点击阶段进行编辑。箭头表示循环。",
    "previewLinear": "点击阶段进行编辑。最后阶段后结束。",
    "copyToHospital": "复制到本院",
    "copied": "已复制，现在可以编辑",
    "archive": "归档",
    "restore": "恢复",
    "archived": "已归档",
    "lastUpdated": "{{name}} 于 {{date}} 更新",
    "patientCycles": "治疗周期",
    "enroll": "开始治疗周期",
    "enrolled": "已开始治疗周期",
    "pickStartStage": "点击阶段作为起点（默认第一阶段）",
    "noPlans": "暂无治疗周期",
    "showEnded": "显示已结束（{{count}}）",
    "hideEnded": "隐藏已结束",
    "startedOn": "开始于 {{date}}",
    "since": "自 {{date}}",
    "advance": "进入下一阶段",
    "advanceTo": "将患者移至",
    "startsCycle": "开始第 {{n}} 轮",
    "completesPlan": "这是最后阶段：治疗周期将完成。",
    "moveTo": "移至阶段",
    "addNote": "备注",
    "stop": "停止周期",
    "history": "历史",
    "event": {
      "STARTED": "开始",
      "ADVANCED": "下一阶段",
      "MOVED": "调整阶段",
      "NEW_CYCLE": "新一轮",
      "COMPLETED": "完成",
      "STOPPED": "停止",
      "NOTE": "备注"
    }
  },
  "portal": {
    "cardTitle": "患者应用",
    "noAccount": "尚未使用患者应用。",
    "contact": "电话/邮箱",
    "createdVia": "注册方式",
    "via": {
      "SELF_REGISTRATION": "自助注册（新患者）",
      "SELF_LINKED": "自助注册（匹配档案）",
      "STAFF_ACTIVATION": "前台激活码"
    },
    "lastLogin": "最近登录",
    "verifiedBy": "身份核验人",
    "pendingHelp": "通过应用注册。请核对身份证后点击“核验身份”。",
    "activeCode": "未使用的激活码有效至 {{date}}",
    "issueActivation": "开通应用",
    "newActivation": "新激活码",
    "verifyIdentity": "核验身份",
    "verified": "身份已核验",
    "disable": "停用应用",
    "enable": "启用应用",
    "disableConfirm": "患者将在所有手机上退出，重新启用前无法登录。",
    "activationTitle": "患者应用激活",
    "activationFor": "激活对象",
    "activationExpires": "有效至 {{date}}",
    "step1": "安装 HMS 应用并选择“我是患者”。",
    "step2": "点击“创建账户”，输入手机号或邮箱及此激活码。",
    "step3": "输入收到的一次性验证码完成。",
    "activationOnce": "激活码只显示一次，请打印或让患者立即扫描。",
    "identifyTitle": "扫码识别患者",
    "identifyHelp": "请患者在应用中打开“我的健康码”并扫描。",
    "pasteCode": "或粘贴扫码枪读取的内容",
    "identify": "识别",
    "cameraUnavailable": "无法使用摄像头，请用扫码枪或粘贴内容。",
    "stopCamera": "关闭摄像头",
    "startCamera": "开启摄像头",
    "hasAllergies": "有 {{count}} 条过敏记录，治疗前请核对。",
    "checkIdCard": "应用自助注册：治疗前请核对身份证。",
    "appointmentsToday": "今日预约",
    "checkedIn": "已签到",
    "openRecord": "打开病历",
    "giveTicket": "发放排队号",
    "scanAnother": "继续扫描",
    "adminTitle": "患者应用",
    "adminSubtitle": "患者如何开通，以及演示网关发送的消息",
    "flowActivation": "已在医院建档",
    "flowActivationText": "打开患者档案并点击“开通应用”。患者在应用中扫描二维码（或输入激活码）并用一次性验证码确认。",
    "flowSelf": "手机自助注册",
    "flowSelfText": "患者输入手机号或邮箱、姓名和出生日期并确认验证码。匹配到档案则关联；否则新建档案，首次就诊时核验身份。",
    "flowVisit": "后续就诊",
    "flowVisitText": "患者出示健康码二维码，工作人员在“患者”或“排队”页面扫码，打开档案、签到或发号。患者也可在应用中取号。",
    "dummyGateway": "演示模式：短信/邮件和银行支付均为模拟。一次性验证码记录在下方（已遮盖）并显示在应用中；不会扣款。",
    "outbox": "消息发件箱（模拟）",
    "outboxEmpty": "暂无消息",
    "destination": "收件人",
    "message": "内容",
    "msgStatus": {
      "SIMULATED": "模拟"
    },
    "appStatus": {
      "VERIFIED": "应用 · 已验证",
      "PENDING_VERIFICATION": "应用 · 待核验证件",
      "DISABLED": "应用 · 已停用"
    },
    "appStatusHelp": {
      "VERIFIED": "已在患者应用注册并核验身份",
      "PENDING_VERIFICATION": "通过应用注册；下次就诊时核验身份证",
      "DISABLED": "患者应用访问已停用"
    },
    "appFilter": "患者应用",
    "appFilterRegistered": "已在应用注册",
    "appFilterNone": "未在应用注册"
  },
  "patientApp": {
    "iAmPatient": "我是患者",
    "iAmStaff": "医院员工",
    "welcome": "您的健康，尽在掌握",
    "welcomeSub": "查看就诊、结果和账单，取号并出示健康码。",
    "signIn": "登录",
    "register": "创建账户",
    "hospital": "医院",
    "usePhone": "手机",
    "useEmail": "邮箱",
    "phone": "手机号码",
    "email": "电子邮箱",
    "sendCode": "发送验证码",
    "codeSentTo": "请输入发送至 {{destination}} 的6位验证码",
    "code": "验证码",
    "verify": "确认",
    "resend": "重新发送",
    "demoCode": "演示 — 您的验证码是 {{code}}",
    "loginHint": "如您已有账户，将收到验证码。",
    "haveActivation": "我有医院提供的激活码",
    "activationCode": "激活码",
    "firstName": "名",
    "lastName": "姓",
    "dateOfBirth": "出生日期",
    "sex": "性别",
    "newHere": "首次使用？创建账户",
    "haveAccount": "已有账户？登录",
    "pendingBanner": "首次就诊请在挂号处出示身份证件，以解锁全部功能。",
    "home": "首页",
    "records": "病历",
    "queue": "排队",
    "payments": "缴费",
    "profile": "我的",
    "hello": "您好，{{name}}",
    "myId": "我的健康码",
    "idHelp": "在医院窗口或医生处出示此二维码。",
    "refreshesIn": "{{s}} 秒后刷新",
    "nextAppointment": "下次预约",
    "noAppointment": "暂无预约",
    "yourTicket": "您的排队号",
    "position": "前方第 {{n}} 位",
    "eta": "约 {{min}} 分钟",
    "calledNow": "轮到您了 — {{counter}}",
    "takeTicket": "取号",
    "chooseDepartment": "选择科室",
    "waitingCount": "{{count}} 人等候",
    "noTicket": "今日暂无排队号，到院后可取号。",
    "visits": "就诊记录",
    "diagnoses": "诊断",
    "prescriptions": "用药",
    "labResults": "检验结果",
    "eyeHealth": "眼健康",
    "treatmentCycles": "我的治疗",
    "noRecords": "暂无就诊记录",
    "outstanding": "待缴",
    "pay": "支付",
    "choosePayment": "选择支付方式",
    "method": {
      "QR": "扫码支付",
      "CARD": "银行卡",
      "BANK_TRANSFER": "银行转账",
      "MOBILE_MONEY": "移动钱包"
    },
    "dummyCheckout": "演示支付 — 不会扣款。请选择要模拟的银行结果。",
    "approve": "模拟：银行通过",
    "decline": "模拟：银行拒绝",
    "paymentApproved": "支付成功，谢谢！",
    "paymentDeclined": "支付被拒绝，请重试或到收费处缴费。",
    "bills": "账单",
    "paymentHistory": "缴费记录",
    "noInvoices": "暂无账单",
    "noPayments": "暂无缴费",
    "balance": "余额",
    "total": "合计",
    "notifications": "消息",
    "noNotifications": "暂无消息",
    "notify": {
      "DIAGNOSIS": "医生记录了诊断（{{ref}}）",
      "QUEUE_CALLED": "正在叫您的号 {{ref}}",
      "EncounterCompleted": "就诊 {{ref}} 小结已生成",
      "PrescriptionIssued": "新处方 {{ref}}",
      "LabResultVerified": "检验结果已出（{{ref}}）",
      "InvoiceCreated": "新账单 {{ref}}",
      "PaymentCompleted": "已收到付款 {{ref}}",
      "EyeExaminationSigned": "您的眼科检查结果已出",
      "EyeSurgeryScheduled": "已安排眼科手术（{{ref}}）",
      "AppointmentBooked": "已预约（{{ref}}）"
    },
    "allergies": "过敏",
    "bloodGroup": "血型",
    "stageNow": "当前：{{stage}}",
    "instructions": "注意事项",
    "signOut": "退出登录",
    "settings": "语言与主题",
    "verifiedAccount": "身份已核验",
    "pendingAccount": "待核验身份",
    "patientNumber": "患者编号",
    "continue": "继续",
    "sexAge": "性别 · 年龄",
    "address": "地址",
    "registeredOn": "医院登记日期",
    "myInformation": "我的信息",
    "infoHelp": "如需更正信息，请联系挂号处。",
    "outcome": {
      "ALREADY_REGISTERED": {
        "title": "您已注册",
        "text": "该手机号或邮箱已有账户（{{mrn}}），您已登录。"
      },
      "LINKED": {
        "title": "账户已创建",
        "text": "已找到您的病历 {{mrn}} 并关联到账户，现在可以查看就诊、结果和账单。"
      },
      "CREATED": {
        "title": "账户已创建",
        "text": "欢迎！您的新患者编号是 {{mrn}}。"
      },
      "ACTIVATED": {
        "title": "应用已激活",
        "text": "您的账户已关联病历 {{mrn}}。"
      }
    },
    "appName": "HMS 患者版"
  },
  "print": {
    "eyeCenterName": "眼科治疗与保健中心",
    "eyeRegistration": "打印眼科登记表",
    "patientCode": "患者编号",
    "queueNo": "排队号",
    "fullName": "姓名",
    "dateOfBirth": "出生日期",
    "sex": "性别",
    "age": "年龄",
    "years": "{{count}} 岁",
    "occupation": "职业",
    "disability": "残疾患者",
    "village": "村",
    "district": "县",
    "province": "省",
    "phone": "电话",
    "registeredOn": "登记日期",
    "registeredBy": "登记人",
    "patientInfo": "患者信息",
    "newPatient": "新患者",
    "returningPatient": "复诊患者",
    "examDetails": "检查详情",
    "titleFemale": "女士",
    "titleMale": "先生",
    "downloadPdf": "下载 PDF (A4)"
  },
  "reports": {
    "title": "报表",
    "subtitle": "运行、打印和导出医院的所有报表",
    "catalog": "报表目录",
    "total": "合计",
    "run": "生成报表",
    "exportCsv": "导出 CSV",
    "quickRange": "快速范围",
    "thisMonth": "本月",
    "lastMonth": "上月",
    "thisYear": "今年",
    "pickReport": "从目录中选择一个报表",
    "pressRun": "设置期间后点击“生成报表”",
    "period": "期间",
    "rows": "行数",
    "truncated": "仅显示前 5,000 行，请缩小期间。",
    "printedAt": "打印时间",
    "noRows": "该期间无数据",
    "category": {
      "PATIENTS": "患者",
      "CLINICAL": "临床",
      "SERVICES": "服务",
      "FINANCE": "财务",
      "OPERATIONS": "运营",
      "EYE": "眼科中心",
      "INVENTORY": "药品与耗材库存",
      "PROCUREMENT": "采购",
      "EQUIPMENT": "医疗设备",
      "INPATIENT": "住院",
      "SALES": "药房销售"
    },
    "r": {
      "patients-registered": {
        "title": "登记患者",
        "desc": "期间内登记的所有患者及地址"
      },
      "patients-by-address": {
        "title": "按地址统计患者",
        "desc": "按省、县统计患者"
      },
      "demographics": {
        "title": "人口统计",
        "desc": "按年龄组和性别统计就诊患者"
      },
      "appointments": {
        "title": "预约",
        "desc": "期间内的所有预约"
      },
      "visits-by-department": {
        "title": "按科室就诊",
        "desc": "每日各科室各类型就诊"
      },
      "visits": {
        "title": "就诊登记",
        "desc": "所有就诊及诊断"
      },
      "morbidity": {
        "title": "疾病统计 (ICD-10)",
        "desc": "按编码、性别和年龄段统计病例"
      },
      "medications": {
        "title": "用药统计",
        "desc": "各药品的处方量和发药量"
      },
      "laboratory": {
        "title": "检验工作量",
        "desc": "已开单、已审核及异常的检验"
      },
      "revenue-daily": {
        "title": "每日收入",
        "desc": "每日开票、折扣和收款"
      },
      "revenue-by-service": {
        "title": "按服务收入",
        "desc": "各服务类别的收费金额"
      },
      "payments": {
        "title": "收款记录",
        "desc": "所有付款及方式和收款人"
      },
      "outstanding": {
        "title": "未结余额",
        "desc": "未付发票及账龄"
      },
      "queue-performance": {
        "title": "排队绩效",
        "desc": "号票、等待和服务时间"
      },
      "care-plans": {
        "title": "治疗周期",
        "desc": "各路径和阶段的患者"
      },
      "patient-app": {
        "title": "患者应用使用情况",
        "desc": "账户、激活、号票和付款"
      },
      "staff-activity": {
        "title": "员工活动",
        "desc": "每位员工记录的操作"
      },
      "eye-exams": {
        "title": "眼科检查",
        "desc": "含视力、眼压和诊断的检查"
      },
      "eye-surgeries": {
        "title": "眼科手术",
        "desc": "含主刀、人工晶体和结果的手术"
      },
      "eye-injections": {
        "title": "玻璃体腔注射",
        "desc": "含药物和批号的注射"
      },
      "eye-high-iop": {
        "title": "高眼压",
        "desc": "最近眼压高于 21 mmHg"
      },
      "eye-follow-ups": {
        "title": "眼科随访",
        "desc": "已安排和逾期的眼科复查"
      },
      "inventory-stock": {
        "title": "现有库存",
        "desc": "按物品和仓库的数量、成本与价值"
      },
      "inventory-low-stock": {
        "title": "低库存与补货",
        "desc": "达到再订货点的物品及建议订货量"
      },
      "inventory-expiry": {
        "title": "有效期报告",
        "desc": "截至结束日期已过期或将到期的批次"
      },
      "inventory-movements": {
        "title": "库存流水账",
        "desc": "期间内所有库存变动"
      },
      "inventory-consumption": {
        "title": "按物品消耗",
        "desc": "发药与领用数量、金额及可用天数"
      },
      "inventory-consumption-department": {
        "title": "按科室消耗",
        "desc": "处方及各科室的消耗金额"
      },
      "inventory-valuation": {
        "title": "库存估值",
        "desc": "按类型和类别的库存价值"
      },
      "inventory-adjustments": {
        "title": "调整与报损",
        "desc": "期初、更正、报损及退货"
      },
      "inventory-abc": {
        "title": "ABC 分析",
        "desc": "按消耗金额排序（A 类 = 前 80%）"
      },
      "purchase-requests": {
        "title": "请购单",
        "desc": "期间内创建的请购单及状态和金额"
      },
      "purchase-orders": {
        "title": "采购订单",
        "desc": "期间内的订单、已收及未到金额"
      },
      "goods-receipts": {
        "title": "收货明细",
        "desc": "每条收货记录及批号、有效期和成本"
      },
      "supplier-performance": {
        "title": "供应商绩效",
        "desc": "各供应商的订购额、准时率与交期"
      },
      "equipment-register": {
        "title": "设备台账",
        "desc": "全部医疗设备及位置、保修和保养"
      },
      "equipment-maintenance": {
        "title": "保养记录",
        "desc": "期间内的保养、校准与维修"
      },
      "equipment-due": {
        "title": "待保养设备",
        "desc": "截至结束日期到期或逾期保养的设备"
      },
      "ipd-census": {
        "title": "在院患者",
        "desc": "所有在院患者及床位、天数和预计出院日期"
      },
      "ipd-admissions": {
        "title": "入院记录",
        "desc": "期间入院记录，含类型、病区和结局"
      },
      "ipd-discharges": {
        "title": "出院记录",
        "desc": "期间出院患者、住院天数和复诊"
      },
      "ipd-occupancy": {
        "title": "床位使用率",
        "desc": "各病区床位、占用床日和使用率"
      },
      "ipd-length-of-stay": {
        "title": "住院天数",
        "desc": "各病区平均、最短、最长住院天数及出院方式"
      },
      "special-services": {
        "title": "特殊服务明细",
        "desc": "所有X光、超声、心电图等申请及状态和出报告时间"
      },
      "special-services-summary": {
        "title": "特殊服务汇总",
        "desc": "各服务的申请数、完成数、待处理数和收入"
      },
      "sales-daily": {
        "title": "每日柜台销售",
        "desc": "每日销售、折扣、退款、现金和毛利"
      },
      "sales-items": {
        "title": "畅销商品",
        "desc": "各商品销量、退货、收入、成本和毛利"
      },
      "sales-transactions": {
        "title": "销售小票",
        "desc": "所有柜台销售及收银员、付款和退货"
      },
      "finance-profit-loss": {
        "title": "损益表",
        "desc": "收入、销售成本、费用和净利润"
      },
      "finance-revenue-sources": {
        "title": "收入来源",
        "desc": "按科室的账单和柜台销售"
      },
      "finance-discounts": {
        "title": "折扣明细",
        "desc": "账单和柜台的所有折扣及原因"
      },
      "finance-expenses": {
        "title": "费用明细",
        "desc": "费用及登记人、审批人"
      },
      "finance-cash-sessions": {
        "title": "收银班次",
        "desc": "应有与实点现金、差额及核对"
      },
      "finance-price-list": {
        "title": "价目表",
        "desc": "所有收费、药品、检验、服务、床位和商品价格"
      },
      "finance-price-changes": {
        "title": "调价记录",
        "desc": "原价、新价、原因和调整人"
      },
      "stock-documents": {
        "title": "库存单据",
        "desc": "入库、出库和调拨及制单人、审核人"
      },
      "morbidity-by-type": {
        "title": "按疾病类别的发病情况",
        "desc": "按疾病类别分组的确诊病例，含需上报病例、性别和年龄段"
      }
    },
    "col": {
      "abnormal": "异常",
      "abnormalRate": "异常率",
      "actions": "操作数",
      "activationCodes": "激活码",
      "activePatients": "在治患者",
      "administeredBy": "执行人",
      "age": "年龄",
      "age15to49": "15–49",
      "age50plus": "50+",
      "age5to14": "5–14",
      "ageGroup": "年龄组",
      "ageing": "账龄",
      "amount": "金额",
      "appPaid": "应用内支付",
      "appPayments": "应用付款笔数",
      "appTickets": "应用取号",
      "appointmentNumber": "预约号",
      "avgServiceMinutes": "平均服务(分钟)",
      "avgTurnaroundMinutes": "平均周转(分钟)",
      "avgWaitMinutes": "平均等待(分钟)",
      "balance": "余额",
      "caseNumber": "病例号",
      "cases": "病例数",
      "category": "类别",
      "code": "编码",
      "collected": "已收款",
      "completedInRange": "已完成",
      "complications": "并发症",
      "creates": "新建",
      "date": "日期",
      "dateOfBirth": "出生日期",
      "daysOverdue": "逾期天数",
      "department": "科室",
      "diagnoses": "诊断",
      "diagnosis": "诊断",
      "discount": "折扣",
      "district": "县",
      "doctor": "医生",
      "emergency": "急诊",
      "encounterNumber": "就诊号",
      "examinedBy": "检查者",
      "eye": "眼别",
      "female": "女",
      "form": "剂型",
      "fromApp": "来自应用",
      "gross": "总额",
      "indication": "适应症",
      "invoiceNumber": "发票号",
      "invoices": "发票数",
      "iol": "人工晶体",
      "iop": "眼压 (mmHg)",
      "iopOd": "眼压 OD",
      "iopOs": "眼压 OS",
      "issuedAt": "开具日期",
      "lastActivity": "最近活动",
      "lines": "明细数",
      "lotNumber": "批号",
      "male": "男",
      "maxWaitMinutes": "最长等待(分钟)",
      "measuredAt": "测量时间",
      "medication": "药品",
      "method": "方式",
      "mrn": "患者编号",
      "net": "净额",
      "newAccounts": "新账户",
      "newInRange": "期内新增",
      "newPatients": "新患者",
      "nextFollowUp": "下次随访",
      "opd": "门诊",
      "ordered": "开单",
      "other": "其他",
      "outstanding": "未收",
      "overdueReviews": "逾期复查",
      "paidAt": "付款时间",
      "pathway": "治疗路径",
      "patientName": "患者",
      "patients": "患者数",
      "paymentNumber": "付款号",
      "phone": "电话",
      "postOpVa": "术后视力",
      "practitioner": "医师",
      "prescriptions": "处方数",
      "procedureName": "手术名称",
      "province": "省",
      "quantity": "数量",
      "quantityDispensed": "已发药",
      "quantityPrescribed": "处方量",
      "reason": "原因",
      "receivedBy": "收款人",
      "registeredAt": "登记时间",
      "registeredBy": "登记人",
      "scheduledStart": "预约时间",
      "selfRegistered": "自助注册",
      "served": "已服务",
      "sex": "性别",
      "share": "占比",
      "signatures": "签署",
      "skipped": "过号",
      "staff": "员工",
      "stage": "阶段",
      "startedAt": "开始时间",
      "startedInRange": "期内开始",
      "status": "状态",
      "surgeon": "主刀医生",
      "test": "检验项目",
      "tickets": "号票",
      "total": "合计",
      "type": "类型",
      "under5": "5岁以下",
      "updates": "修改",
      "vaOd": "视力 OD",
      "vaOs": "视力 OS",
      "value": "金额",
      "verified": "已审核",
      "views": "查看",
      "village": "村",
      "itemCode": "编码",
      "item": "物品",
      "itemType": "类型",
      "store": "仓库",
      "unit": "单位",
      "onHand": "现有",
      "usable": "可用",
      "unitCost": "单价",
      "stockValue": "库存价值",
      "reorderLevel": "再订货点",
      "nextExpiry": "最近到期",
      "onOrder": "在途",
      "avgDailyUse": "日均",
      "daysOfCover": "可用天数",
      "suggestedQuantity": "建议订货量",
      "estimatedCost": "预估成本",
      "expiryDate": "有效期",
      "daysLeft": "剩余天数",
      "expiryStatus": "状态",
      "performedAt": "日期时间",
      "movementType": "业务类型",
      "balanceAfter": "结存",
      "reference": "单据",
      "performedBy": "操作人",
      "dispensed": "处方发药",
      "issued": "科室领用",
      "totalUsed": "合计消耗",
      "items": "物品数",
      "expiredValue": "过期金额",
      "abcClass": "ABC 分类",
      "cumulativeShare": "累计占比",
      "prNumber": "请购单号",
      "createdAt": "创建时间",
      "requestedBy": "申请人",
      "priority": "优先级",
      "estimatedTotal": "预估总额",
      "decidedBy": "审批人",
      "decidedAt": "审批时间",
      "orders": "订单",
      "poNumber": "采购单号",
      "orderDate": "下单日期",
      "supplier": "供应商",
      "expectedDate": "预计到货",
      "receivedValue": "已收金额",
      "outstandingValue": "未到金额",
      "approvedBy": "批准人",
      "receivedAt": "收货时间",
      "grnNumber": "收货单号",
      "orderedValue": "订购金额",
      "onTimeRate": "准时率",
      "avgLeadDays": "平均交期（天）",
      "lateOrders": "延误订单",
      "assetTag": "资产编号",
      "serialNumber": "序列号",
      "model": "型号",
      "location": "位置",
      "purchaseDate": "购买日期",
      "purchaseCost": "购置成本",
      "warrantyExpiry": "保修至",
      "nextMaintenance": "下次保养",
      "maintenanceStatus": "保养状态",
      "eventType": "类型",
      "cost": "费用",
      "statusAfter": "之后状态",
      "nextDueDate": "下次到期",
      "notes": "备注",
      "dueDate": "到期日",
      "admissionNumber": "住院号",
      "admissionType": "类型",
      "admissions": "入院数",
      "admittedAt": "入院时间",
      "againstAdvice": "自动出院",
      "attending": "主治医生",
      "available": "空床",
      "averageDays": "平均天数",
      "bed": "床位",
      "bedDays": "床日",
      "beds": "床位数",
      "cancelled": "取消",
      "cash": "现金",
      "cashier": "收银员",
      "changeRate": "变动%",
      "changedAt": "调整时间",
      "changedBy": "调整人",
      "checkedAt": "审核时间",
      "checkedBy": "审核人",
      "cleaning": "清洁中",
      "closedAt": "关闭时间",
      "completed": "完成",
      "countedCash": "实点",
      "customer": "顾客",
      "days": "天数",
      "deceased": "死亡",
      "description": "说明",
      "destination": "去向",
      "dischargeType": "出院去向",
      "dischargedAt": "出院时间",
      "dischargedBy": "办理人",
      "discharges": "出院数",
      "discountType": "方式",
      "discountValue": "折扣值",
      "docNumber": "单据号",
      "docType": "类型",
      "entityType": "类型",
      "expectedCash": "应有",
      "expectedDischarge": "预计出院",
      "expenseDate": "日期",
      "expenseNumber": "费用单号",
      "followUpDate": "复诊",
      "home": "回家",
      "line": "项目",
      "margin": "毛利",
      "marginRate": "毛利率",
      "maxDays": "最长",
      "minDays": "最短",
      "name": "名称",
      "newPrice": "新价格",
      "nonCash": "非现金",
      "occupancyRate": "使用率",
      "occupied": "占用",
      "oldPrice": "原价格",
      "openedAt": "开启时间",
      "openingFloat": "备用金",
      "orderNumber": "申请单号",
      "orderedAt": "申请时间",
      "outOfService": "停用",
      "payee": "收款方",
      "paymentMethod": "付款方式",
      "pending": "待处理",
      "preparedBy": "制单人",
      "price": "价格",
      "recordedBy": "登记人",
      "referred": "转诊",
      "refunded": "已退款",
      "refunds": "退款",
      "reportedBy": "报告人",
      "returned": "退货",
      "revenue": "收入",
      "saleNumber": "销售单号",
      "sales": "销售笔数",
      "section": "部分",
      "service": "服务",
      "sessionNumber": "班次",
      "sold": "销售",
      "soldAt": "销售时间",
      "source": "来源",
      "turnaroundMinutes": "出报告用时（分）",
      "variance": "差额",
      "verifiedBy": "审核人",
      "ward": "病区",
      "diseaseType": "疾病类别",
      "notifiableCases": "需上报病例"
    },
    "from": "从",
    "to": "至"
  },
  "locations": {
    "title": "地区",
    "subtitle": "老挝的省、县、乡/片区和村",
    "counts": "{{provinces}} 个省 · {{districts}} 个县 · {{villages}} 个村",
    "pickDistrict": "选择一个县以管理其乡/片区和村",
    "addSubdistrict": "添加乡/片区",
    "editSubdistrict": "编辑乡/片区",
    "noSubdistricts": "尚无乡/片区。请添加并分配村。",
    "villageCount": "{{count}} 个村",
    "assignVillages": "分配村",
    "searchVillage": "搜索村",
    "nameLa": "名称（老挝语）",
    "nameEn": "名称（英语）",
    "inOtherSubdistrict": "属于 {{name}}"
  },
  "inventory": {
    "title": "药品、药房与医疗设备库存",
    "subtitle": "库存、批次与有效期、请购单与采购订单、供应商及医疗设备",
    "item": "物品",
    "items": "物品",
    "name": "名称",
    "itemType": "类型",
    "category": "类别",
    "unit": "单位",
    "manufacturer": "生产商",
    "unitCost": "单位成本",
    "unitCostShort": "成本 {{value}} / 单位",
    "reorderLevel": "再订货点",
    "reorderLevelHint": "可用库存降到此水平时提醒并建议订货",
    "reorderQuantity": "再订货量",
    "maxLevel": "最高库存",
    "maxLevelHint": "超过此水平视为库存过多",
    "maxShort": "最高 {{value}}",
    "trackExpiry": "跟踪批号和有效期",
    "controlled": "管制药品",
    "controlledShort": "管制",
    "storageCondition": "储存条件",
    "linkMedication": "药品（药房目录）",
    "linkMedicationHint": "已关联药品在按处方发药时自动扣减库存",
    "noMedicationLink": "不关联（不按处方发药）",
    "fromMedication": "取自药品信息",
    "newItem": "新建物品",
    "editItem": "编辑物品",
    "searchItem": "搜索药品、耗材或设备…",
    "noItems": "未找到物品",
    "usable": "可用库存",
    "onHand": "现有",
    "onOrder": "在途",
    "stockValue": "库存价值",
    "stockStatus": "库存状态",
    "daysOfCover": "可用天数",
    "days": "{{count}} 天",
    "daysLeft": "剩 {{count}} 天",
    "expiredAgo": "已过期 {{count}} 天",
    "overdueDays": "逾期 {{count}} 天",
    "nextExpiry": "最近到期",
    "assetsCount": "{{count}} 台",
    "allStores": "全部仓库",
    "allSuppliers": "全部供应商",
    "store": "仓库",
    "storeType": "仓库类型",
    "newStore": "新建仓库",
    "editStore": "编辑仓库",
    "dispensing": "发药",
    "dispensingStore": "处方从此仓库发药",
    "dispensingStoreHint": "药房发药时从此仓库扣减已关联药品的库存。",
    "fromStore": "来源仓库",
    "toStore": "目标仓库",
    "toDepartment": "领用科室",
    "department": "科室",
    "deliverTo": "送货至",
    "supplier": "供应商",
    "newSupplier": "新建供应商",
    "editSupplier": "编辑供应商",
    "noSuppliers": "暂无供应商",
    "contact": "联系方式",
    "contactPerson": "联系人",
    "phone": "电话",
    "email": "电子邮件",
    "address": "地址",
    "taxId": "税号",
    "paymentTerms": "付款条件",
    "leadTimeDays": "交货周期（天）",
    "leadDays": "{{count}} 天到货",
    "orders": "订单",
    "receivedValueShort": "已收货金额",
    "lots": "批次",
    "lotNumber": "批号",
    "expiryDate": "有效期",
    "noLots": "暂无库存批次",
    "lotsAndExpiry": "批次与有效期",
    "ledger": "库存流水账",
    "allLots": "全部批次",
    "expiredOnly": "已过期",
    "within": "≤ {{count}} 天",
    "lotsTotal": "{{count}} 个批次 · {{value}}",
    "lotsCount": "{{count}} 个批次",
    "lotSummary": "批次 {{lot}}（{{store}}）：{{quantity}}",
    "receivedAt": "入库时间",
    "movementType": "业务类型",
    "quantity": "数量",
    "balanceAfter": "结存",
    "reference": "单据",
    "performedAt": "日期 / 时间",
    "performedBy": "操作人",
    "noMovements": "暂无库存流水",
    "recentMovements": "最近流水",
    "clearItemFilter": "显示全部物品",
    "byStore": "各仓库库存",
    "usageByMonth": "每月入库与消耗",
    "avgDailyUse": "日均用量",
    "coverDays": "约可用 {{count}} 天",
    "noUse": "近 90 天无消耗",
    "expiredQty": "过期库存",
    "equipmentHint": "设备按台跟踪（已登记 {{count}} 台）。",
    "openEquipment": "打开设备台账",
    "addStock": "增加库存",
    "stockAdded": "已增加库存",
    "adjustmentType": "类型",
    "reason": "原因",
    "removeFromLot": "出库",
    "stockRemoved": "已出库",
    "issue": "领用出库",
    "issueStock": "发放到科室",
    "issued": "已发放 {{number}}",
    "transfer": "调拨",
    "transferStock": "仓库间调拨",
    "transferred": "已调拨 {{number}}",
    "fefoHint": "按先到期先出（FEFO）原则扣减。",
    "requestPurchase": "申请采购",
    "warnings": "预警",
    "noWarnings": "无预警——库存、有效期和设备均正常",
    "seeAll": "查看全部",
    "uncategorized": "未分类",
    "updatedAt": "更新于 {{time}}",
    "requestOnlyHint": "您可在“请购单”页签中创建请购单。",
    "purchaseRequest": "请购单",
    "purchaseOrder": "采购订单",
    "prNumber": "请购单号",
    "poNumber": "采购单号",
    "newRequest": "新建请购单",
    "editRequest": "编辑请购单 {{number}}",
    "newOrder": "新建采购订单",
    "editOrder": "编辑采购订单 {{number}}",
    "noRequests": "暂无请购单",
    "noOrders": "暂无采购订单",
    "mineOnly": "仅我的申请",
    "createdAt": "创建时间",
    "created": "创建",
    "requestedBy": "申请人",
    "requestedByOn": "{{name}} 于 {{date}} 申请",
    "requestingDepartment": "申请科室",
    "priority": "优先级",
    "neededBy": "需求日期",
    "reasonForRequest": "申请理由",
    "estimatedUnitCost": "预估单价",
    "estimatedTotal": "预估总额",
    "lineTotal": "小计",
    "saveDraft": "保存草稿",
    "saveAndSubmit": "保存并提交审批",
    "submit": "提交审批",
    "approve": "批准",
    "reject": "驳回",
    "approveRequest": "批准 {{number}}",
    "rejectRequest": "驳回 {{number}}",
    "approveHint": "逐行核定数量；填 0 表示删除该行。",
    "requested": "申请数",
    "approvedQty": "核准数",
    "decisionNote": "审批意见",
    "cancelRequest": "取消请购",
    "cancelRequestConfirm": "请购单将被取消，不能再下单。",
    "selfApprovalHint": "此申请由您提交，需由其他审批人决定。",
    "selfApprovalPoHint": "此订单由您编制，需由其他审批人批准。",
    "awaitingApproval": "等待采购审批人批准。",
    "prSubmitted": "请购单已提交审批",
    "prApproved": "请购单已批准",
    "prRejected": "请购单已驳回",
    "prCancelled": "请购单已取消",
    "createPo": "生成采购订单",
    "poCreated": "已生成采购订单 {{number}}",
    "history": "记录",
    "details": "详情",
    "reorderSuggestions": "补货建议",
    "suggestionsHint": "已达或低于再订货点的物品（扣除在途数量），建议量补足到最高库存。",
    "noSuggestions": "目前无需补货",
    "createPrFromSelection": "生成请购单（{{count}} 项）",
    "reorderReason": "补充已达再订货点的物品",
    "orderDate": "下单日期",
    "orderedOn": "下单于 {{date}}",
    "expectedDate": "预计到货",
    "expectedDateHint": "留空：今天 + 供应商交货周期",
    "overdue": "逾期",
    "total": "合计",
    "ordered": "订购",
    "received": "已收",
    "receivedValue": "已收 {{value}}",
    "outstanding": "未到货",
    "saveOrder": "保存采购订单",
    "markSent": "标记为已发给供应商",
    "receive": "收货",
    "receiveGoods": "收货 — {{number}}",
    "receiveHint": "填写到货数量。药品等有效期物品须填写批号和有效期；不得接收过期物品。",
    "receiveQty": "本次收货",
    "required": "必填",
    "deliveryNote": "送货单号",
    "confirmReceipt": "确认收货",
    "goodsReceived": "已收货入库",
    "goodsReceipts": "收货记录",
    "noReceipts": "尚未收货",
    "closeShort": "关闭（余量不再到货）",
    "closeShortConfirm": "订单将按已收数量关闭。",
    "cancelOrder": "取消订单",
    "poApproved": "采购订单已批准",
    "poSent": "采购订单已发出",
    "poCancelled": "采购订单已取消",
    "poClosed": "采购订单已关闭",
    "preparedBy": "编制人",
    "approvedBy": "批准人",
    "supplierAcknowledgement": "供应商确认",
    "description": "品名",
    "equipment": "设备",
    "newAsset": "登记设备",
    "editAsset": "编辑设备",
    "noAssets": "暂无登记设备",
    "equipmentType": "设备类型",
    "equipmentTypeHint": "类型为“设备”的物品（请先在“物品”中创建）。",
    "searchEquipment": "搜索设备、资产编号、序列号或位置…",
    "assetTag": "资产编号",
    "assetTagHint": "留空：自动编号",
    "serialNumber": "序列号",
    "model": "型号",
    "location": "位置",
    "purchaseDate": "购买日期",
    "purchaseCost": "购置成本",
    "purchasedFor": "{{date}} 以 {{value}} 购入",
    "warrantyExpiry": "保修至",
    "underWarranty": "在保修期内",
    "warrantyEnded": "保修已过期",
    "maintenanceInterval": "保养周期（天）",
    "lastMaintenance": "上次保养",
    "lastOn": "上次 {{date}}",
    "nextMaintenance": "下次保养",
    "nextMaintenanceHint": "留空：上次保养 + 周期",
    "maintenanceDueOnly": "到期保养",
    "maintenanceCost": "保养费用",
    "serviceHistory": "保养与维修记录",
    "noEvents": "暂无保养记录",
    "logEvent": "登记维护记录 — {{tag}}",
    "logEventShort": "登记保养",
    "eventType": "类型",
    "eventDate": "日期",
    "cost": "费用",
    "statusAfter": "之后状态",
    "noChange": "不变",
    "nextDueDate": "下次到期",
    "nextDueHint": "留空：今天 + 保养周期",
    "recordedBy": "记录人",
    "tab": {
      "dashboard": "统计",
      "items": "物品",
      "stock": "库存",
      "requests": "请购单",
      "orders": "采购订单",
      "suppliers": "供应商",
      "equipment": "医疗设备",
      "alerts": "预警",
      "stores": "仓库",
      "stockIn": "入库",
      "stockOut": "出库",
      "transfers": "调拨",
      "toCheck": "待审核",
      "posRefills": "POS 补货申请"
    },
    "kpi": {
      "stockValue": "库存价值",
      "itemsCount": "{{count}} 个物品",
      "outOfStock": "缺货",
      "lowCount": "低库存 {{count}}",
      "lowStock": "低库存",
      "overCount": "超储 {{count}}",
      "expiring30": "30 天内到期",
      "expiredLots": "已过期 {{count}} 批 · {{value}}",
      "prPending": "待审批请购",
      "prApproved": "已批准未下单 {{count}}",
      "poOpen": "未完成采购单",
      "poOverdue": "逾期 {{count}} · 未到 {{value}}",
      "equipment": "医疗设备",
      "maintenance": "到期 {{due}} · 逾期 {{overdue}}"
    },
    "chart": {
      "flowByMonth": "每月入库、消耗与报损",
      "received": "入库",
      "consumed": "消耗",
      "writtenOff": "报损",
      "valueByCategory": "各类别库存价值",
      "topConsumed": "消耗最多（90 天，按金额）",
      "expiryTimeline": "每月到期库存价值",
      "expiringValue": "将到期",
      "spendBySupplier": "按供应商采购额（12 个月）"
    },
    "severity": {
      "danger": "紧急 {{count}}",
      "warning": "警告 {{count}}",
      "info": "提示 {{count}}"
    },
    "alert": {
      "OUT_OF_STOCK": "缺货",
      "LOW_STOCK": "低库存",
      "OVERSTOCK": "库存过多",
      "EXPIRED": "已过期",
      "EXPIRING": "即将到期",
      "PO_OVERDUE": "到货逾期",
      "PO_APPROVAL": "订单待审批",
      "PR_PENDING": "请购待审批",
      "MAINTENANCE_OVERDUE": "保养逾期",
      "MAINTENANCE_DUE": "保养到期",
      "WARRANTY_EXPIRING": "保修即将到期",
      "ASSET_OUT_OF_SERVICE": "设备停用",
      "stockDetail": "可用 {{usable}} · 再订货点 {{reorder}} · 在途 {{onOrder}}",
      "overDetail": "可用 {{usable}} · 最高 {{max}}",
      "lotDetail": "批次 {{lot}} · {{store}} · {{quantity}} · {{date}} · {{value}}",
      "poOverdueDetail": "{{supplier}} · 预计 {{date}}（逾期 {{count}} 天）",
      "prDetail": "{{by}} · {{priority}}"
    },
    "barcode": "条码",
    "grnNumber": "收货单",
    "margin": "毛利率 {{value}}%",
    "noPictures": "暂无图片，可添加一张或多张商品照片。",
    "notForSale": "不销售",
    "pictures": "图片与售价",
    "salePrice": "售价",
    "salePriceDrugHint": "处方和柜台销售使用同一价格",
    "salePriceHint": "药房柜台售价",
    "sellable": "柜台可售",
    "docs": {
      "availableNow": "当前可用",
      "cancelConfirm": "单据将被取消，库存不变。",
      "cancelTitle": "取消单据",
      "cancelled": "单据已取消",
      "checkNote": "审核备注",
      "checkedBy": "审核人",
      "destination": "去向",
      "fefo": "近效期先出",
      "lineCount": "{{count}} 行",
      "newRequisition": "新建领用单",
      "newStockIn": "新建入库单",
      "newWriteOff": "报损 / 退货",
      "none": "暂无单据",
      "nothingToCheck": "没有待您审核的单据",
      "number": "单据号",
      "pendingCheck": "待审核",
      "pickItem": "选择要入库的物品",
      "pickLotHint": "报损和退货从单个批次出库。请选择物品，然后在批次上点击“出库”。",
      "post": "审核过账",
      "postConfirm": "库存将立即变动，请核对实物的数量、批号和效期。",
      "postTitle": "过账 {{number}}",
      "posted": "{{number}} 已过账，库存已更新",
      "receiptDocuments": "收货单及审核",
      "receiptHint": "收货单需由第二人核对实物后过账入库。",
      "receiveFromPo": "按采购订单收货",
      "receivedBy": "接收人",
      "reference": "参考",
      "reject": "驳回",
      "rejectReason": "驳回原因",
      "rejected": "单据已驳回",
      "rejectedBecause": "已驳回：{{note}}",
      "shortNow": "部分行库存不足，过账将失败。",
      "storeKeeper": "库管员",
      "submitForCheck": "提交审核",
      "submitRequisition": "提交领用单",
      "submitted": "{{number}} 已提交审核",
      "type": "类型",
      "value": "金额",
      "waitingForChecker": "等待第二人（审核人）过账。",
      "inHint": "入库：采购收货、期初库存和盘点调整。每张单据由第二人审核过账。",
      "outHint": "出库：科室领用、报损、调整和退供应商。仅在第二人过账后库存才减少。",
      "transferHint": "调拨在仓库间移动库存，保留批号和效期，由第二人过账。",
      "checkHint": "他人制作的单据，等待您核对实物后过账或驳回。"
    }
  },
  "gallery": {
    "add": "添加图片",
    "main": "主图",
    "makeMain": "设为主图",
    "next": "下一张",
    "previous": "上一张",
    "none": "暂无图片",
    "open": "查看图片"
  },
  "inpatient": {
    "title": "住院管理",
    "subtitle": "入院、转床与出院，按天计算床位费",
    "addBed": "添加床位",
    "addRoom": "添加病房",
    "admissionNumber": "住院号",
    "admissionType": "入院类型",
    "admit": "收住院",
    "admitPatient": "收治患者",
    "admitted": "已入院：{{number}}",
    "admittedAt": "入院时间",
    "admittingDiagnosis": "入院诊断",
    "allWards": "全部病区",
    "attending": "主治医生",
    "attendingDefault": "未指定",
    "bed": "床位",
    "bedCharges": "床位费",
    "bedChargesSoFar": "目前床位费",
    "bedDayRule": "床日按过夜（零点）计算，按床位单价收费；当天出院计一天。",
    "bedNumber": "床号",
    "bedStays": "床位使用记录",
    "bedType": "床位类型",
    "beds": "床位",
    "billAfterDischarge": "床位费在出院后结算",
    "billed": "已结算",
    "by": "经办：{{name}}",
    "cancelAdmission": "取消入院",
    "cancelHint": "仅用于误收入院，床位释放且不收费。",
    "cancelled": "入院已取消",
    "cancelledBecause": "已取消：{{reason}}",
    "capacity": "容量",
    "clinical": "临床信息",
    "createBill": "生成账单",
    "dailyRate": "每日费用",
    "dailyRateHint": "本房间每张床按夜收费",
    "day": "天",
    "dayN": "第 {{count}} 天",
    "discharge": "出院",
    "dischargeAnyway": "仍然出院",
    "dischargeDiagnosis": "出院诊断",
    "dischargeHint": "床位转入清洁，床位费可结算。",
    "dischargeMedications": "出院带药",
    "dischargeSummary": "出院小结",
    "dischargeTitle": "为 {{name}} 办理出院",
    "dischargeType": "出院去向",
    "discharged": "患者已出院",
    "dischargedAt": "出院时间",
    "editRoom": "编辑病房",
    "editWard": "编辑病区",
    "expectedDischarge": "预计出院",
    "expectedShort": "预计 {{date}} 出院",
    "floor": "{{floor}} 楼",
    "floorLabel": "楼层",
    "followUpDate": "复诊日期",
    "followUpInstructions": "出院医嘱",
    "from": "开始",
    "lengthOfStay": "住院天数",
    "markClean": "已清洁",
    "moveReason": "原因",
    "newBed": "新床位",
    "newWard": "新建病区",
    "nights": "{{count}} 晚",
    "nightsHeader": "晚数",
    "noAdmissions": "暂无入院记录",
    "noFreeBeds": "没有空床",
    "noRooms": "暂无病房",
    "noWards": "暂无病区，请先设置病区、病房和床位。",
    "notBilledYet": "尚未结算",
    "now": "至今",
    "occupancy": "床位使用率",
    "occupiedOf": "{{occupied}}/{{total}} 床",
    "openChart": "打开病历",
    "patient": "患者",
    "patientOrRelative": "患者或家属",
    "pendingWork": "本次住院尚有未完成工作",
    "pending": {
      "serviceOrders": "{{count}} 项特殊服务未完成",
      "labOrders": "{{count}} 项检验未完成",
      "prescriptions": "{{count}} 张处方未发药",
      "draftNotes": "{{count}} 条记录未签名"
    },
    "printNote": "请保存本小结并在复诊时携带。",
    "reason": "入院原因",
    "release": "释放",
    "room": "病房",
    "roomN": "病房 {{room}}",
    "roomType": "病房类型",
    "searchAdmissions": "姓名、病历号或住院号",
    "to": "结束",
    "transfer": "转床",
    "transferBed": "转床",
    "transferHint": "当前在 {{bed}}，原床位转入清洁。",
    "transferred": "已转至 {{bed}}",
    "visit": "就诊号",
    "ward": "病区",
    "wardType": "病区类型",
    "searchBeds": "患者、病历号、房间或床位",
    "admittedToday": "今日入院",
    "dueOutToday": "今日预计出院",
    "overdueOut": "已超过预计出院日 {{date}}",
    "noBedsMatch": "没有符合筛选条件的床位",
    "wardOccupied": "已用 {{occupied}}/{{total}} 张床",
    "admittedAtField": "入院日期和时间",
    "admittedAtHint": "默认为现在；补录时可往前调（最多 30 天）",
    "dischargedAtField": "出院日期和时间",
    "dischargedAtHint": "默认为现在；不得早于入院时间（{{at}}）",
    "admittedShort": "入院 {{at}}"
  },
  "services": {
    "title": "特殊检查与服务",
    "subtitle": "X光、CT、超声、心电图、内镜、理疗及操作",
    "allCategories": "全部类别",
    "billedWithVisit": "随就诊结算",
    "cancelItem": "取消 {{name}}",
    "cancelOrder": "取消申请",
    "category": "类别",
    "clinicalInfo": "临床信息",
    "complete": "完成",
    "duration": "时长",
    "durationMinutes": "时长（分钟）",
    "editReport": "修改报告",
    "editService": "编辑服务",
    "findings": "所见",
    "impression": "结论",
    "inpatient": "住院",
    "itemCancelled": "服务已取消",
    "markDone": "完成 {{name}}",
    "minutes": "{{count}} 分钟",
    "newService": "新增服务",
    "noImages": "无影像",
    "noOrders": "暂无特殊服务申请",
    "noReport": "无需报告",
    "open": "待处理",
    "order": "申请特殊服务",
    "orderCancelled": "申请已取消",
    "orderFor": "为 {{name}} 申请特殊服务",
    "orderNumber": "申请单号",
    "ordered": "已申请：{{number}}",
    "orderedAt": "申请时间",
    "orderedBy": "申请医生",
    "performedBy": "执行：{{name}} {{at}}",
    "preparation": "检查前准备",
    "preparationHint": "开单时显示，如空腹",
    "prepareNote": "准备：{{text}}",
    "printReport": "打印报告",
    "priority": "优先级",
    "recommendation": "建议",
    "report": "报告",
    "reportHint": "提交后由他人审核，审核后才作为最终报告给医生。",
    "reportTitle": "检查报告",
    "reportVerified": "报告，需第二人审核",
    "reported": "报告已提交审核",
    "done": "服务已完成",
    "reportedBy": "报告：{{name}} {{at}}",
    "reporter": "报告人",
    "requiresReport": "需要书面报告（第二人审核）",
    "searchCatalog": "查找服务",
    "searchOrders": "姓名、病历号或申请单号",
    "service": "服务",
    "services": "服务项目",
    "start": "开始",
    "started": "已开始",
    "submitReport": "提交报告",
    "verified": "报告已审核",
    "verifiedBy": "审核：{{name}} {{at}}",
    "verifier": "审核人",
    "verify": "审核",
    "waitingMin": "已等待 {{count}} 分钟",
    "waitingVerify": "等待他人审核您的报告。",
    "writeReport": "报告：{{name}}",
    "writeReportShort": "书写报告"
  },
  "pos": {
    "title": "药房收银台",
    "subtitle": "销售药品、耗材和医疗器械",
    "alreadyReturned": "已退",
    "cart": "购物篮",
    "cartEmpty": "点击商品加入",
    "cashReceived": "实收现金",
    "cashier": "收银员",
    "change": "找零",
    "charge": "收款 {{total}}",
    "controlledNeedsPatient": "管制药品只能售给已登记患者",
    "customer": "顾客",
    "customerName": "顾客姓名",
    "giveChange": "找零：{{value}}",
    "inStock": "库存 {{qty}}",
    "netTotal": "{{count}} 笔销售 · 净额 {{value}}",
    "nextCustomer": "下一位顾客",
    "noCashRight": "您无权收取现金，请选择其他付款方式。",
    "noProducts": "该仓库没有可售商品",
    "noReturns": "无退货",
    "noSales": "本期无销售",
    "openDrawerFirst": "请先开启收银班次再收现金",
    "patientOptional": "患者（可选）",
    "purchases": "购买记录",
    "receipt": "收据",
    "recordReturn": "退货",
    "refundMethod": "退款方式",
    "refunded": "已退款",
    "returnHint": "退货将回到原批次。",
    "returnQty": "退货数量",
    "returnTitle": "{{number}} 退货",
    "returned": "退货已记录，库存已恢复",
    "returns": "退货",
    "saleDiscount": "整单折扣",
    "saleDone": "销售 {{number}} 完成",
    "saleNumber": "销售单号",
    "salesTitle": "柜台销售",
    "searchOrScan": "搜索或扫描条码",
    "searchSales": "单号、顾客、电话或病历号",
    "sold": "已售",
    "soldAt": "销售时间",
    "supervisorHint": "退货和作废由主管（他人）办理。",
    "suppliesDevices": "耗材与器械",
    "void": "作废销售",
    "voidHint": "全部退回库存，该销售不再计入收银班次；仅限班次未关闭时。",
    "voided": "销售已作废",
    "voidedBecause": "由 {{name}} 作废：{{reason}}",
    "outlet": "POS 门店",
    "noOutlet": "尚无使用中的 POS 门店。",
    "catalog": {
      "title": "医疗 POS 商品目录",
      "subtitle": "柜台销售的商品及价格。商品来自仓库物品。",
      "tab": "商品目录",
      "search": "名称、代码、条码或类别",
      "addFromWarehouse": "从仓库添加",
      "addHint": "选择要在 POS 销售的仓库物品。初始价格为建议售价，之后可修改。",
      "allPublished": "所有仓库物品均已在 POS 目录中。",
      "publishCount": "添加 {{count}} 项到 POS",
      "published": "已添加 {{count}} 项到 POS",
      "empty": "POS 目录中暂无商品",
      "product": "商品",
      "price": "POS 售价",
      "posStock": "POS 库存",
      "warehouseStock": "仓库",
      "levels": "低于 → 补至",
      "hide": "在 POS 隐藏",
      "show": "在 POS 显示",
      "editTitle": "POS 商品：{{name}}",
      "warehouseItem": "仓库物品",
      "displayName": "POS 显示名称",
      "displayNameHint": "留空 = 使用仓库名称",
      "suggested": "建议价：{{price}}",
      "sortOrder": "显示顺序",
      "minLevel": "低于或等于此数时补货",
      "minLevelHint": "含在途数量",
      "parLevel": "补货至",
      "parLevelHint": "0 = 不自动建议",
      "parBelowMin": "不得低于补货点",
      "posPicture": "POS 图片",
      "useWarehousePicture": "使用仓库图片",
      "publishedHint": "在 POS 显示并销售"
    },
    "outlets": {
      "title": "门店",
      "add": "新增门店",
      "edit": "编辑门店",
      "empty": "暂无门店",
      "hint": "每个门店有自己的库存。只有仓库发出补货且门店确认收货后，库存才会到达。",
      "codeHint": "简短代码，如 POS2",
      "inUse": "使用中",
      "products": "有库存商品",
      "incoming": "在途"
    },
    "stock": {
      "title": "POS 库存与补货",
      "subtitle": "门店库存、在途货品及向仓库的补货申请",
      "products": "商品",
      "inTransit": "在途",
      "onHand": "POS 现有",
      "nextExpiry": "最近到期",
      "expired": "已过期",
      "empty": "暂无数据"
    },
    "refill": {
      "request": "申请补货",
      "requestHint": "已自动填入达到补货点的商品，补至目标数量。可按需修改数量。",
      "fromStore": "发货仓库",
      "nothingLow": "没有商品低于补货点。如需要可在下方添加。",
      "quantity": "数量",
      "addProduct": "添加商品",
      "saveDraft": "存为草稿",
      "send": "提交给仓库",
      "created": "已创建补货申请 {{number}}",
      "submitted": "已提交给仓库",
      "listTitle": "补货申请",
      "inboxTitle": "来自医疗 POS 的补货申请",
      "open": "进行中",
      "empty": "暂无补货申请",
      "number": "申请单",
      "route": "从 → 到",
      "lines": "商品",
      "requestedBy": "申请人",
      "preparedBy": "备货人（仓库）",
      "sentAt": "发出时间",
      "receivedBy": "收货人",
      "transfer": "仓库调拨单",
      "requested": "申请",
      "inStore": "{{store}} 现有",
      "sent": "已发",
      "received": "已收",
      "short": "短缺",
      "toSend": "发货数",
      "prepare": "准备调拨",
      "prepareTitle": "准备补货 {{number}}",
      "prepareHint": "POS 正在等待这些商品。请准备调拨单，由另一名仓库人员核对并发出。",
      "prepareDialogHint": "数量默认为申请数，但不超过仓库现有数。数量为 0 的商品不发货。",
      "prepared": "调拨单 {{doc}} 已准备 — 等待核对人发出",
      "preparingHint": "仓库已备货。另一名仓库人员在 库存 → 待核对 中核对并发出：",
      "waitingWarehouse": "等待仓库备货。",
      "sendHint": "过账此调拨单会从仓库扣减库存；POS 确认收货后才进入门店。补货申请",
      "inTransitHint": "正在发往 POS。POS 清点到货并确认收货。补货申请",
      "fromRequest": "为 POS 补货准备",
      "receive": "收货",
      "receiveTitle": "收货 {{number}}",
      "receiveHint": "货物在途。请清点到货并确认收货，之后才能销售。",
      "receiveDialogHint": "请填写实际到货数量。短缺部分会被记录，并需填写备注。",
      "receiveNote": "备注（短缺原因）",
      "confirmReceipt": "确认收货",
      "receivedOk": "已收货 — 商品现可销售",
      "receivedShort": "收货有短缺：{{note}}",
      "shortValue": "短缺金额：{{value}}",
      "moreThanSent": "超过发货数量",
      "moreThanStore": "超过仓库现有数量",
      "reject": "拒绝",
      "rejectTitle": "拒绝补货 {{number}}",
      "rejectReason": "原因",
      "rejected": "已拒绝补货申请",
      "rejectedBecause": "仓库已拒绝：{{reason}}",
      "cancelTitle": "取消补货 {{number}}",
      "cancelHint": "仓库将不再处理此申请。"
    }
  },
  "finance": {
    "title": "财务管理",
    "subtitle": "价格与收费、收银班次、费用与经营结果",
    "tab": {
      "dashboard": "概览",
      "prices": "价格与收费",
      "sessions": "收银班次",
      "expenses": "费用",
      "history": "调价记录"
    },
    "allCategories": "全部类别",
    "amount": "金额",
    "approveExpense": "批准 {{number}}",
    "approvedTotal": "已批准：{{value}}",
    "balanced": "金额相符",
    "byMethod": "按付款方式",
    "cashExpenseHint": "从钱箱支付的现金计入您当前的收银班次。",
    "cashExpenses": "现金支出",
    "cashPayments": "账单现金收款",
    "cashRefunds": "现金退款",
    "cashSales": "柜台现金销售",
    "changePrice": "调价",
    "changePriceOf": "{{name}} 的价格",
    "changeReason": "调整原因",
    "changedAt": "调整时间",
    "changedBy": "调整人",
    "closeDrawer": "关闭收银班次 {{number}}",
    "closeDrawerShort": "关账",
    "closeNote": "清点备注",
    "closed": "关闭时间",
    "collected": "实收",
    "cost": "成本",
    "costOfGoods": "药品耗材成本",
    "countedCash": "实点现金",
    "counterSales": "柜台销售",
    "currentPrice": "当前 {{value}}",
    "dailyCash": "每日收支",
    "date": "日期",
    "decidedBy": "审批人",
    "discountReason": "折扣原因",
    "discountType": "折扣方式",
    "discountable": "可打折",
    "discountableHint": "此收费项目允许打折",
    "discounts": "已给折扣",
    "drawerOpenShort": "班次 {{number}} · {{cash}}",
    "drawers": "未关闭班次",
    "editFee": "编辑收费项目",
    "expectedCash": "应有现金",
    "expenseApprovalHint": "费用需由他人批准后才计入。",
    "expenseNumber": "费用单号",
    "expenseOnlyHint": "您可以登记费用，由财务部门审批。",
    "expenseRecorded": "费用 {{number}} 已提交审批",
    "expenses": "费用",
    "expensesByCategory": "按类别费用",
    "grossProfit": "毛利 {{value}}",
    "item": "项目",
    "lastChange": "最近调价",
    "margin": "毛利率",
    "myDrawer": "我的收银班次",
    "netProfit": "净利润",
    "newExpense": "登记费用",
    "newFee": "新增收费项目",
    "newPrice": "新价格",
    "noChanges": "无调价记录",
    "noExpenses": "无费用",
    "noOpenDrawer": "您没有未关闭的收银班次。",
    "noSessions": "无收银班次",
    "oldPrice": "原价格",
    "openDrawer": "开启收银班次",
    "openDrawerHint": "清点钱箱零钱并输入为备用金。",
    "opened": "开启时间",
    "openedAt": "开启于 {{at}}",
    "openingFloat": "备用金",
    "otherVerifies": "必须由他人清点并核对此班次。",
    "outstanding": "应收未收",
    "payee": "收款方",
    "pendingApproval": "{{count}} 项待审批",
    "percent": "百分比",
    "percentValue": "百分比（%）",
    "price": "价格",
    "priceChangeHint": "新账单使用新价格，已有账单保持原价，所有调价均记入历史。",
    "priceSaved": "价格已调整",
    "pricesHint": "所有收费、药品、检验、特殊服务、床位和商品价格都在这里；折扣可在账单或柜台按金额或百分比给予。",
    "recordedBy": "登记人",
    "rejectExpense": "驳回 {{number}}",
    "revenue": "收入",
    "revenueBySource": "收入来源",
    "revenueSplit": "账单 {{invoices}} · 柜台 {{sales}}",
    "searchPrices": "按名称或编码查找",
    "session": "收银班次",
    "sessionClosed": "班次 {{number}} 已关闭，待核对",
    "sessionOpened": "班次 {{number}} 已开启",
    "sessionTitle": "班次 {{number}} · {{name}}",
    "sessionVerified": "班次已核对",
    "submitExpense": "提交审批",
    "taxRate": "税率（%）",
    "toVerify": "{{count}} 个已关闭待核对",
    "type": "类型",
    "variance": "差额",
    "varianceIs": "差额 {{value}}，请说明原因",
    "verifiedBy": "核对人",
    "verifyCount": "确认核对"
  },
  "diseases": {
    "title": "疾病目录",
    "subtitle": "用于诊断和报表的 ICD-10 编码、名称和疾病类别",
    "tabDiseases": "疾病",
    "tabTypes": "疾病类别",
    "searchPlaceholder": "按 ICD-10 编码或名称搜索…",
    "type": "疾病类别",
    "allTypes": "所有类别",
    "notifiableOnly": "仅法定报告传染病",
    "newDisease": "新增疾病",
    "empty": "没有匹配的疾病",
    "code": "ICD-10 编码",
    "codeHint": "如 A90 或 J06.9；以大写保存",
    "name": "名称",
    "nameLo": "名称（老挝语）",
    "nameEn": "名称（英语）",
    "notifiable": "需上报",
    "notifiableShort": "上报",
    "notifiableHint": "法定报告疾病：病例须上报卫生部门",
    "notifiableWarning": "{{name}} 是需上报的疾病，请记得上报该病例。",
    "noType": "— 无类别 —",
    "activeHint": "启用（选择诊断时显示）",
    "activeTypeHint": "启用",
    "deleteDisease": "删除疾病",
    "deleteDiseaseMessage": "从目录中删除 {{code}}？已记录的诊断保留其编码和文字。",
    "deleted": "已删除",
    "newType": "新增疾病类别",
    "noTypes": "暂无疾病类别",
    "diseaseCount": "疾病数",
    "sortOrder": "显示顺序",
    "color": "颜色",
    "customColor": "自定义颜色",
    "preview": "预览",
    "typeInUseHint": "有 {{count}} 种疾病使用此类别，无法删除。请移走疾病或停用该类别。",
    "deleteType": "删除疾病类别",
    "deleteTypeMessage": "删除疾病类别 {{code}}？",
    "pickFromCatalog": "在疾病目录中查找"
  },
  "national": {
    "title": "国家报告",
    "subtitle": "KPI 结果、已批准的报告快照和 DHIS2 数据报送",
    "tab": {
      "dashboard": "KPI 概览",
      "snapshots": "报告快照",
      "catalog": "KPI 目录",
      "batches": "DHIS2 报送",
      "mappings": "DHIS2 映射",
      "connections": "DHIS2 连接"
    },
    "period": "报告期",
    "calculate": "计算 KPI",
    "calculated": "KPI 已计算",
    "lastRun": "最近计算 {{at}}，由 {{by}}",
    "notCalculatedYet": "本期尚未计算 KPI。请点击“计算 KPI”。",
    "notCalculatedReadOnly": "本期尚未计算 KPI。",
    "notCalculated": "未计算",
    "noKpis": "没有 KPI",
    "target": "目标",
    "warning": "警戒值",
    "warningAt": "警戒值 {{value}}",
    "numeratorDenominator": "分子 / 分母",
    "formulaVersion": "公式第 {{n}} 版",
    "trend": "最近六期",
    "breakdown": "分组",
    "report": "报告",
    "allReports": "全部报告",
    "allStatuses": "全部状态",
    "allTypes": "全部类型",
    "generateSnapshot": "生成快照",
    "generate": "生成",
    "noSnapshots": "暂无报告快照",
    "version": "版本",
    "checks": "检查",
    "clean": "无问题",
    "errors": "错误：{{count}}",
    "warnings": "警告：{{count}}",
    "generated": "生成时间",
    "approvedBy": "批准人",
    "includesKpis": "本报告包含：",
    "generateHint": "KPI 会重新计算并冻结为新的编号版本。必须由您以外的人批准后才能报送。",
    "snapshotGenerated": "快照已生成",
    "snapshotValidated": "快照已校验",
    "snapshotApproved": "快照已批准",
    "snapshotInvalidated": "快照已作废",
    "invalidate": "作废",
    "validate": "校验",
    "approve": "批准",
    "prepareDhis2": "报送 DHIS2…",
    "cannotApproveOwn": "不能批准自己的工作",
    "generatedBy": "由 {{by}} 于 {{at}} 生成",
    "approvedByAt": "由 {{by}} 于 {{at}} 批准",
    "approvedByName": "由 {{by}} 批准",
    "createdByAt": "由 {{by}} 于 {{at}} 创建",
    "needsOtherApprover": "等待他人批准（职责分离）。",
    "invalidatedBecause": "已作废：{{reason}}",
    "supersededHint": "已有更新的批准版本取代此快照。",
    "values": "数值",
    "kpi": "KPI",
    "value": "数值",
    "formula": "公式",
    "quality": "数据质量",
    "dhis2Batches": "DHIS2 报送",
    "invalidateMessage": "作废的快照不能再报送；尚未发送的批次将被取消。请填写原因。",
    "reason": "原因",
    "connection": "连接",
    "createBatch": "创建批次",
    "noConnections": "尚未设置 DHIS2 连接",
    "createBatchHint": "数值会映射到 DHIS2 数据元并进行检查。批次需他人批准后才会发送。",
    "batchCreated": "批次已创建",
    "noIssues": "未发现问题",
    "issue": {
      "INSUFFICIENT_DATA": "数据过少",
      "NO_FORMULA": "无已批准公式",
      "DIMENSION_TOTAL_MISMATCH": "分组合计不符",
      "PERIOD_OPEN": "报告期未结束",
      "NO_ORG_UNIT_MAPPING": "组织单元未映射",
      "NO_DATA_SET_MAPPING": "数据集未映射",
      "NO_DATA_ELEMENT_MAPPING": "数据元未映射",
      "NO_VALUE": "无数值",
      "NOT_SENT_QUALITY": "未发送（质量）",
      "NO_CATEGORY_MAPPING": "类别未映射",
      "NOTHING_TO_SEND": "没有可发送的数据"
    },
    "catalogHint": "公式为系统内置的计算器。新公式版本须由作者以外的人批准后才会使用。",
    "newKpi": "新建 KPI",
    "category": "类别",
    "unit": "单位",
    "noFormula": "无已批准公式",
    "draftVersions": "草稿版本：{{count}}",
    "nameEn": "名称（英文）",
    "nameLo": "名称（老挝文）",
    "direction": "方向",
    "owner": "负责人",
    "unitFixed": "创建后不能更改单位",
    "newKpiHint": "保存后，请添加公式版本并获批准，然后才能计算 KPI。",
    "newTarget": "新建目标",
    "newFormulaVersion": "新建公式版本",
    "targetNeedsDirection": "请先设置越高越好或越低越好",
    "ownedBy": "负责人：{{owner}}",
    "formulaVersions": "公式版本",
    "definition": "定义",
    "numerator": "分子",
    "denominator": "分母",
    "effective": "生效",
    "minDenominator": "最小分母",
    "targets": "目标",
    "infoNoTarget": "仅供参考的 KPI 没有目标",
    "noTargets": "暂无目标",
    "formulaApproved": "公式版本已批准",
    "formulaDrafted": "公式草稿已保存",
    "calculator": "计算器",
    "parameters": "参数（JSON）",
    "parametersInvalid": "请输入 JSON 对象，例如 {\"windowDays\": 30}",
    "effectiveFrom": "生效日期",
    "changeRationale": "变更原因",
    "saveDraft": "保存草稿",
    "formulaApprovalHint": "新版本批准后自生效日起使用；上一版本在前一天结束。",
    "lowerBetterHint": "越低越好：等于或低于目标为达成，高于目标但不超过警戒值为警告。",
    "higherBetterHint": "越高越好：等于或高于目标为达成，低于目标但不低于警戒值为警告。",
    "batchesHint": "批次在后台发送，DHIS2 不可用时会自动重试。",
    "noBatches": "暂无 DHIS2 报送",
    "batch": "批次",
    "batchApproved": "批次已批准",
    "batchQueued": "批次已排队等待发送",
    "batchReconciled": "已与 DHIS2 核对",
    "batchCancelled": "批次已取消",
    "cancelBatch": "取消批次",
    "send": "发送到 DHIS2",
    "retry": "重新发送",
    "reconcile": "核对",
    "dataSetOrgUnit": "数据集 {{ds}} · 组织单元 {{ou}}",
    "batchHasErrors": "此批次有错误，无法发送。请修正映射，取消此批次后创建新批次。",
    "reconcileHint": "DHIS2 未及时响应。请先核对读取已存数值，再决定是否重新发送。",
    "nextAttempt": "下次自动尝试 {{at}}",
    "dataValues": "数据值",
    "noValues": "无数值",
    "dataElement": "数据元",
    "categoryOptionCombo": "类别选项组合 (COC)",
    "importResults": "导入结果",
    "counts": "数量",
    "countsLine": "导入 {{imported}}，更新 {{updated}}，忽略 {{ignored}}，共 {{total}}",
    "conflicts": "冲突",
    "activity": "活动",
    "showPayload": "显示发送内容",
    "hidePayload": "隐藏发送内容",
    "mappingType": "映射类型",
    "newMapping": "新建映射",
    "noMappings": "没有映射",
    "local": "HMS 对象",
    "onlyFor": "仅用于 {{report}}",
    "notInMetadata": "元数据中不存在",
    "transform": "数值转换",
    "retire": "停用",
    "mappingApproved": "映射已批准",
    "mappingRetired": "映射已停用",
    "mappingDrafted": "映射草稿已保存",
    "dhis2Object": "DHIS2 对象",
    "refreshMetadataFirst": "请先刷新 DHIS2 元数据",
    "cocHint": "以合计值发送时使用",
    "defaultCoc": "default",
    "scopeReport": "仅用于报告",
    "scopeReportHint": "同一 KPI 在另一报告中对应不同数据元时使用",
    "anyReport": "任意报告",
    "mappingApprovalHint": "映射须由创建者以外的人批准后才会使用。",
    "connectionsHint": "HMS 不保存凭据：请填写服务器上保存凭据的环境变量名称。",
    "newConnection": "新建连接",
    "connectionOk": "已连接 DHIS2",
    "connectionFailed": "无法连接 DHIS2",
    "metadataRefreshed": "元数据已刷新",
    "auth": "认证",
    "secretSet": "已设置",
    "secretMissing": "服务器上未设置",
    "lastHealth": "检查于 {{at}}",
    "lastMetadata": "元数据 {{at}}",
    "approvedMappings": "已批准映射：{{count}}",
    "draftMappings": "草稿映射：{{count}}",
    "testConnection": "测试连接",
    "refreshMetadata": "刷新元数据",
    "baseUrl": "基础 URL",
    "baseUrlHint": "例如 https://dhis2.example.gov.la（链接中不要包含用户名或密码）",
    "environment": "环境",
    "apiVersion": "API 版本",
    "authPat": "个人访问令牌",
    "authBasic": "用户名和密码",
    "secretReference": "环境变量",
    "secretHint": "在服务器上设置该变量：个人访问令牌填写令牌，基本认证填写 username:password。",
    "enabled": "启用",
    "urlError": {
      "invalid": "请输入不含用户名或密码的 http(s) 链接",
      "httpsRequired": "生产环境必须使用 https"
    },
    "periodOpenText": "报告期尚未结束，数值可能仍会变化。",
    "msg": {
      "minRecords": "仅有 {{count}} 条记录；至少需要 {{min}} 条",
      "noData": "本期无数据",
      "noFormula": "本期没有已批准的公式版本",
      "stockPoint": "计算时的库存状况",
      "medianNote": "两个时间均有记录的排队号的中位数",
      "breakdownGap": "分组合计为 {{sum}}，总数为 {{total}}（性别或出生日期不详）"
    }
  },
  "tenants": {
    "title": "租户与医院",
    "subtitle": "使用本系统的机构及其医院。每家医院拥有各自的患者、员工、库存和财务数据。",
    "newTenant": "新建租户",
    "none": "暂无租户",
    "suspend": "暂停",
    "activate": "启用",
    "deactivate": "停用",
    "addHospital": "添加医院",
    "noHospitals": "暂无医院",
    "hospital": "医院",
    "users": "用户",
    "patients": "患者",
    "created": "创建时间",
    "signInLink": "登录链接",
    "linkCopied": "登录链接已复制",
    "openHospital": "打开",
    "current": "当前登录",
    "sharedCatalogNote": "药品、检验项目、收费项目和特殊服务是全国共享目录，价格也共享。按租户分开定价将在租户隔离强化阶段实现。",
    "codeHint": "大写短代码，例如 MOH 或 OPI",
    "type": "类型",
    "nameLo": "名称（老挝文）",
    "nameEn": "名称（英文）",
    "hospitalCodeHint": "唯一代码，也用于登录链接",
    "startingData": "初始数据",
    "startingDataHint": "每家新医院都会获得疾病目录、KPI 目录和国家报告。预约类型以及（可选的）科室将从另一家医院复制。",
    "copyFrom": "复制设置自",
    "noTemplate": "不复制",
    "copyDepartments": "同时复制科室",
    "firstAdmin": "首位管理员",
    "adminNew": "新账户",
    "adminExisting": "现有用户",
    "adminLater": "稍后",
    "passwordHint": "至少 8 个字符，包含大写字母、小写字母和数字；管理员登录后自行修改",
    "grantMe": "允许我访问此医院（用于设置）",
    "createHospital": "创建医院",
    "hospitalCreated": "医院已创建并完成设置"
  },
  "referrals": {
    "title": "转诊",
    "subtitle": "我们转往其他机构的患者以及转入本院的患者，包括回复和结果",
    "new": "新建转诊",
    "refer": "转诊",
    "none": "没有转诊",
    "number": "转诊编号",
    "direction": "方向",
    "patient": "患者",
    "facility": "机构",
    "reason": "转诊原因",
    "priority": "紧急程度",
    "open": "未完成",
    "search": "按编号、患者或机构搜索…",
    "outLong": "本院转出",
    "inLong": "转入本院",
    "toFacility": "转往",
    "fromFacility": "转自",
    "facilityContact": "机构联系方式",
    "specialty": "专科 / 服务",
    "diagnosis": "诊断",
    "clinicalSummary": "临床摘要",
    "clinicalSummaryHint": "病史、检查所见、检验结果及已有治疗",
    "transport": "交通方式",
    "created": "转诊已创建",
    "sent": "已标记为已发送",
    "printLetter": "打印转诊单",
    "printSummary": "打印摘要",
    "logContact": "记录联系",
    "markSent": "标记为已发送",
    "markUnreachable": "无法联系",
    "decline": "被拒绝",
    "accept": "已接收",
    "complete": "记录结果",
    "byOn": "由 {{by}} 于 {{at}}",
    "encounter": "就诊",
    "appointmentAt": "预约",
    "contactAttempts": "联系次数",
    "response": "回复",
    "outcome": "结果",
    "cancelledBecause": "已取消：{{reason}}",
    "history": "记录",
    "contactResult": "联系结果",
    "step": {
      "accept": "转诊已被接收",
      "decline": "转诊被拒绝",
      "unreachable": "无法联系该机构",
      "complete": "转诊结果",
      "cancel": "取消转诊",
      "contact": "与机构或患者联系"
    },
    "done": {
      "accept": "转诊已接收",
      "decline": "已拒绝",
      "unreachable": "已标记为无法联系",
      "complete": "结果已记录",
      "cancel": "已取消",
      "contact": "联系已记录"
    },
    "noteLabel": {
      "accept": "备注（接收人、指示）",
      "decline": "拒绝原因",
      "unreachable": "已尝试的方式",
      "complete": "结果（诊断、治疗、计划）",
      "cancel": "取消原因",
      "contact": "备注"
    },
    "letterTitle": "转诊单",
    "summaryTitle": "转入患者",
    "referringClinician": "转诊医生",
    "receivingFacility": "接收机构",
    "feedbackRequest": "反馈",
    "feedbackText": "请回复检查结果和治疗计划，以便我们继续照护该患者。"
  },
  "followUps": {
    "title": "随访",
    "subtitle": "各科室的随访计划：到期、逾期和已完成",
    "new": "新建随访",
    "plan": "安排随访",
    "none": "没有随访",
    "due": "到期日",
    "patient": "患者",
    "reason": "原因",
    "who": "科室 / 医生",
    "outcome": "结果",
    "done": "完成",
    "missed": "未到",
    "reopen": "重新开启",
    "overdueBy": "逾期 {{days}} 天",
    "inDays": "{{days}} 天后",
    "created": "随访已安排",
    "priority": "紧急程度",
    "department": "科室",
    "practitioner": "医生",
    "instructions": "给患者的指示",
    "instructionsHint": "例如空腹前来、携带药物",
    "filter": {
      "upcoming": "一周内到期",
      "overdue": "逾期",
      "today": "今天到期",
      "week": "未来 7 天"
    },
    "action": {
      "complete": "随访完成",
      "missed": "患者未到",
      "cancel": "取消随访"
    },
    "noteLabel": {
      "complete": "结果",
      "missed": "备注（可选）",
      "cancel": "取消原因"
    }
  },
  "duplicates": {
    "title": "重复患者",
    "subtitle": "可能属于同一人的记录。由一人申请合并，另一人审批。",
    "tabSuggestions": "可能重复",
    "tabRequests": "合并申请",
    "noneFound": "未发现可能重复的记录",
    "suggestionsHint": "{{count}} 对可能重复，最可能的排在前面",
    "requestPending": "合并等待审批",
    "notDuplicates": "不是同一人",
    "askMerge": "申请合并",
    "dismissed": "此对将不再提示",
    "dismissMessage": "这两条记录属于不同的人，将不再提示。",
    "dismissReason": "原因（如双胞胎、父母与子女）",
    "visits": "{{count}} 次就诊",
    "lastVisit": "最近 {{date}}",
    "registered": "登记于 {{date}}",
    "keepThis": "保留此记录",
    "keeping": "保留的记录",
    "chooseSurvivor": "选择要保留的记录。另一条记录的所有内容将移到此记录。",
    "mergeExplain": "{{merge}} 将合并到 {{keep}}：就诊、账单、结果及其他记录将转移，被合并的记录将不能再使用。",
    "reasonLabel": "原因",
    "sendForApproval": "提交审批",
    "requested": "合并申请已提交审批",
    "noRequests": "没有合并申请",
    "askedBy": "由 {{by}} 于 {{at}} 申请",
    "decidedBy": "由 {{by}} 于 {{at}} 决定",
    "survivor": "保留",
    "duplicate": "合并到保留的记录",
    "decisionNote": "决定备注",
    "movedRecords": "已将 {{count}} 条记录移到保留的患者",
    "keptOnDuplicate": "留在被合并的记录上（每位患者一条）：{{list}}",
    "cancelRequest": "取消申请",
    "reject": "拒绝",
    "approveMerge": "批准合并",
    "mergeNow": "立即合并",
    "approveNote": "备注（可选）",
    "rejectNote": "拒绝原因",
    "merged": "记录已合并",
    "rejected": "合并已拒绝",
    "mergedBanner": "此记录已合并到另一位患者的记录，不能再使用。",
    "openSurvivor": "打开保留的记录",
    "reason": {
      "NAME_DOB": "姓名和出生日期相同",
      "SIMILAR_NAME_DOB": "姓名相似，出生日期相同",
      "PHONE_NAME": "电话相同，姓名相似",
      "IDENTIFIER": "证件号相同"
    }
  },
  "registry": {
    "sectionNamesEn": "英文姓名和昵称",
    "firstNameEn": "名（英文）",
    "lastNameEn": "姓（英文）",
    "nickname": "昵称",
    "nicknameEn": "昵称（英文）",
    "sectionBackground": "基本信息",
    "nationality": "国籍",
    "country": "公民身份（国家）",
    "ethnicity": "民族",
    "religion": "宗教",
    "firstLanguage": "母语",
    "occupation": "职业",
    "educationLevel": "教育程度",
    "sectionBirth": "出生地",
    "birthCountry": "出生国家",
    "birthPlace": "出生地（其他）",
    "birthPlaceHint": "如不是村，填写医院或地点",
    "sectionHousehold": "户籍",
    "houseNo": "门牌号",
    "householdUnit": "组（ໜ່ວຍ）",
    "familyBookNo": "户口簿编号",
    "relationshipToHead": "与户主关系",
    "isHouseholdHead": "户主",
    "sectionParents": "父母",
    "fatherName": "父亲姓名",
    "motherName": "母亲姓名",
    "parentOccupation": "职业",
    "parentPhone": "电话",
    "parentNationalId": "身份证号",
    "parentWorkplace": "工作单位",
    "sectionHealth": "健康背景",
    "hearingIssue": "听力问题",
    "speakingIssue": "言语问题",
    "visionIssue": "眼睛或视力问题",
    "heightCm": "身高（厘米）",
    "weightKg": "体重（公斤）",
    "medicalIssues": "健康问题",
    "seriousIllness": "既往重病",
    "title": "户籍信息",
    "namesEn": "英文姓名",
    "heightWeight": "身高和体重",
    "sectionDisability": "残疾",
    "disabilityTypes": "残疾类型",
    "disabilityTypesHint": "可多选；选中某类型后会显示其子类型。“未知 / 未评估”不能与其他选项同时选择。",
    "disabilityChooseOne": "选择一项",
    "disabilityChooseAny": "可多选"
  },
  "staffKpi": {
    "title": "工作汇总",
    "titleFor": "工作汇总：{{name}}",
    "subtitle": "此账户每月记录的工作，按系统板块分类",
    "backToUsers": "返回用户列表",
    "showAll": "同时显示没有记录的工作",
    "nothing": "{{period}} 没有记录",
    "vsPrevious": "上期 {{value}}",
    "column": "工作汇总",
    "open": "查看",
    "mine": "我的工作汇总",
    "metric": {
      "PATIENTS_REGISTERED": "登记患者",
      "APPOINTMENTS_BOOKED": "预约",
      "QUEUE_CALLED": "从队列叫号",
      "ENCOUNTERS_SEEN": "接诊（作为医生）",
      "VITALS_RECORDED": "记录生命体征",
      "DIAGNOSES_RECORDED": "记录诊断",
      "NOTES_SIGNED": "签署病历",
      "LAB_ORDERS": "开检验单",
      "LAB_RESULTS_ENTERED": "录入检验结果",
      "LAB_RESULTS_VERIFIED": "审核检验结果",
      "SERVICES_REPORTED": "特殊服务报告",
      "REFERRALS_MADE": "转诊",
      "FOLLOW_UPS_DONE": "随访完成",
      "EYE_EXAMS_SIGNED": "签署眼科检查",
      "VA_MEASURED": "视力测量",
      "SURGERIES_PERFORMED": "手术",
      "INJECTIONS_GIVEN": "注射",
      "ADMISSIONS": "住院",
      "DISCHARGES": "出院",
      "PRESCRIPTIONS_WRITTEN": "开处方",
      "DISPENSED": "发药",
      "POS_SALES": "柜台销售",
      "STOCK_DOCUMENTS": "库存单据",
      "INVOICES_ISSUED": "开具账单",
      "PAYMENTS_RECEIVED": "收款笔数",
      "PAYMENTS_AMOUNT": "收款金额",
      "SYSTEM_ACTIONS": "系统操作"
    },
    "team": {
      "title": "员工 KPI",
      "subtitle": "每人每月记录的工作量，与月度目标对比",
      "leaderboard": "排行榜",
      "targets": "目标",
      "metric": "指标",
      "role": "角色",
      "anyRole": "全部角色",
      "showZero": "同时显示没有工作量的员工",
      "rank": "排名",
      "staff": "员工",
      "roles": "角色",
      "department": "科室",
      "thisMonth": "本期",
      "lastMonth": "上期",
      "target": "目标",
      "achievement": "完成率",
      "noTarget": "无目标",
      "total": "团队合计",
      "counted": "有工作量的员工",
      "withTarget": "有目标的员工",
      "metTarget": "达成目标",
      "empty": "该指标在本月没有记录。",
      "supervisionNote": "仅用于管理和辅导——员工 KPI 不上报 DHIS2，也不得用于自动人事决定。",
      "addTarget": "添加目标",
      "editTarget": "编辑目标",
      "appliesTo": "适用于",
      "forRole": "某个角色",
      "forPerson": "某个人",
      "person": "人员",
      "monthlyTarget": "月度目标",
      "monthlyTargetMoney": "月度目标（金额）",
      "targetHint": "按月计。季度 ×3，年 ×12，按日和日期范围按天数折算。个人目标优先于角色目标。",
      "targetsHelp": "角色目标适用于该角色的所有人；个人目标会替代角色目标。",
      "noTargets": "还没有目标。",
      "updated": "最后修改",
      "deleteTarget": "删除目标"
    },
    "dash": {
      "title": "看板",
      "vsLastMonth": "与上期相比",
      "activeStaff": "有工作量的员工",
      "targetsMet": "达成目标",
      "ofTargets": "{{met}} / {{total}}",
      "byArea": "各领域工作量（按时间）",
      "attainment": "本期目标",
      "met": "已达成",
      "close": "接近（70–99%）",
      "behind": "落后（低于 70%）",
      "noTargets": "尚未设置目标——可在“目标”标签页添加。",
      "withoutTarget": "有 {{value}} 名有工作量的员工没有目标。",
      "top5": "前 5 名",
      "byRole": "本期各角色工作量",
      "byRoleHint": "拥有多个角色的人员在每个角色中都计入。",
      "people": "{{value}} 人",
      "workItems": "工作量",
      "heatmap": "每人工作量（按时间）",
      "heatmapHint": "颜色越深＝工作量越多。点击某行查看该员工的汇总。"
    },
    "period": {
      "day": "日",
      "month": "月",
      "quarter": "季度",
      "year": "年",
      "range": "日期范围",
      "from": "从",
      "to": "至",
      "vs": "对比 {{previous}}",
      "prorated": "目标按天数折算"
    },
    "trendTotal": "图表合计 {{value}}"
  },
  "roles": {
    "title": "角色与权限",
    "subtitle": "每个角色是一组权限。在用户页面为员工分配角色。",
    "newRole": "新建角色",
    "howItWorks": "更改会在 15 分钟内对每个人生效（下次登录或令牌刷新时）。角色由所有医院共用；平台权限只属于超级管理员。",
    "searchRoles": "搜索角色…",
    "permissionCount": "{{count}} 项权限",
    "pick": "请选择角色",
    "locked": "已锁定",
    "builtIn": "内置",
    "custom": "自定义",
    "inUse": "仍分配给用户",
    "name": "角色名称",
    "usersLine": "本院 {{here}} 人 · 所有医院 {{total}} 人",
    "saveDetails": "保存信息",
    "lockedHint": "超级管理员始终拥有所有权限。",
    "permissions": "权限（{{count}}）",
    "searchPermissions": "搜索权限…",
    "savePermissions": "保存权限",
    "platformOnly": "仅限平台",
    "deleteRole": "删除角色",
    "deleteMessage": "删除角色 {{name}}？没有人拥有此角色。",
    "create": "创建角色",
    "codeHint": "大写字母和 _，例如 EYE_SCREENER",
    "copyFrom": "复制权限自",
    "startEmpty": "不带任何权限开始",
    "saved": "权限已保存",
    "deleted": "角色已删除",
    "created": "角色已创建"
  },
  "permGroup": {
    "appointment": "预约",
    "audit": "审计日志",
    "billing": "账单",
    "careplan": "护理计划",
    "cash": "收银抽屉",
    "dhis2": "DHIS2",
    "diagnosis": "诊断",
    "disease": "疾病目录",
    "encounter": "就诊",
    "finance": "财务",
    "followup": "随访",
    "i18n": "语言与文字",
    "inpatient": "住院",
    "inventory": "库存",
    "kpi": "KPI",
    "lab": "检验",
    "location": "地点",
    "medication": "药品",
    "note": "临床记录",
    "ophthalmology": "眼科中心",
    "organization": "医院与科室",
    "pathway": "治疗周期",
    "patient": "患者",
    "payment": "收款",
    "pharmacy": "药房",
    "portal": "患者应用",
    "pos": "医疗 POS",
    "prescription": "处方",
    "purchase": "采购",
    "queue": "排队",
    "referral": "转诊",
    "report": "报告",
    "role": "角色",
    "sales": "柜台销售",
    "service": "特殊服务",
    "tenant": "租户",
    "user": "用户",
    "ward": "病区与床位",
    "reference": "共享代码表",
    "staffkpi": "员工 KPI"
  },
  "permAction": {
    "admin": "管理",
    "approve": "批准",
    "collect": "收款",
    "discount": "给予折扣",
    "dispense": "发药",
    "enter": "录入结果",
    "global": "所有医院",
    "manage": "管理",
    "merge": "合并记录",
    "order": "开单",
    "perform": "执行",
    "prepare": "准备",
    "read": "查看",
    "refund": "退款",
    "request": "申请",
    "sell": "销售",
    "sensitive": "敏感信息",
    "session": "开关",
    "sign": "签署",
    "stock": "库存",
    "submit": "提交",
    "surgery": "手术",
    "verify": "审核",
    "void": "作废",
    "write": "创建和编辑",
    "kiosk": "运行自助机",
    "display": "显示叫号屏",
    "triage": "临床优先级",
    "configure": "配置"
  },
  "apptDash": {
    "title": "预约看板",
    "subtitle": "今日排程、本月概览及需要关注的随访",
    "followUpWatch": "随访关注",
    "followUpWatchHint": "已逾期或即将到期的随访计划",
    "followUpRestOfWeek": "未来 7 天内其他日期",
    "patients": "{{value}} 位患者",
    "openFollowUps": "未完成随访",
    "needsAttention": "需要关注",
    "noOverdue": "没有逾期随访。",
    "otherDepartments": "其他",
    "byDepartment": "按科室统计预约",
    "byDepartmentHint": "{{month}} 预约占比",
    "lastMonth": "上月",
    "pillHint": "标签显示与上月相比的变化。",
    "scheduled": "已预约",
    "overview": "预约概览",
    "overviewHint": "{{month}} 合计 · {{date}} 排程",
    "calendar": "预约日历",
    "calendarHint": "选择日期查看排程",
    "more": "另有 {{value}} 条",
    "legend": "图例",
    "legendHint": "日历颜色按科室区分",
    "waiting": "等待中",
    "arrived": "已到达",
    "patientsBooked": "患者",
    "beds": "床位",
    "bedsHint": "住院病区",
    "doctorsOnDuty": "值班医生",
    "activeDoctors": "在岗医生",
    "departmentsOpen": "科室",
    "upcoming": "即将到来",
    "next7Days": "未来 7 天",
    "weekdays": {
      "1": "周一",
      "2": "周二",
      "3": "周三",
      "4": "周四",
      "5": "周五",
      "6": "周六",
      "7": "周日"
    }
  },
  "disabilityTypes": {
    "title": "残疾类型",
    "subtitle": "登记患者时使用的分类，所有医院共用。",
    "new": "新增残疾类型",
    "deleted": "已删除残疾类型",
    "inUseHint": "有 {{count}} 名患者属于此类型，无法删除。取消勾选“使用中”即可在登记中隐藏。",
    "codeHint": "大写字母、数字、- 或 _（例如 PWD11）",
    "sortOrder": "显示顺序",
    "nameLa": "名称（老挝语）",
    "nameEn": "名称（英语）",
    "activeLabel": "使用中（登记患者时显示）",
    "deleteTitle": "删除残疾类型？",
    "deleteMessage": "将删除 {{code}}，没有患者属于此类型。",
    "patients": "患者",
    "parent": "所属上级类型",
    "noParent": "— 主类型 —",
    "icd11Code": "ICD-11 编码",
    "exclusiveLabel": "不能与其他类型同时选择（例如 未知 / 未评估）",
    "singleChoiceLabel": "其子类型只能选择一个",
    "exclusiveBadge": "仅单独选择",
    "singleChoiceBadge": "单一子类型"
  },
  "queueServices": {
    "title": "排队服务点",
    "subtitle": "每个服务点每天都有自己的队列。患者在各服务点之间保持同一号码。",
    "add": "添加服务点",
    "edit": "编辑 {{code}}",
    "prefix": "号码前缀",
    "prefixHint": "字母或数字，如 R 生成 R-001",
    "nameLocal": "名称（老挝语）",
    "nameEn": "名称（英语）",
    "departmentHint": "科室的预约和现场患者从该科室的第一个服务点开始",
    "noDepartment": "无科室",
    "counters": "窗口 / 诊室",
    "countersHint": "用逗号分隔，如 诊室 1, 诊室 2",
    "sortOrder": "顺序",
    "sortOrderHint": "数字小的在前",
    "kiosk": "自助机",
    "kioskEnabled": "现场患者可在自助机选择"
  }
}
